/**
 * Pit ERPNext — Nextcloud web view / location browser (ONE file for both routes).
 *
 * Since 2026-10 this single file serves BOTH pages (Gerald: one web bundle for
 * the whole portal) — the former nextcloud_module/ copy is gone. Only the API
 * endpoints differ and they are handed in by the template via data attributes:
 *   - /nextcloud-location/<loc>  -> nc_location_view.nc_loc_list/_preview/_thumb
 *   - /nextcloud/<view_id>       -> nc_web_view.nc_web_list/_preview/_thumb
 * (login assumed; access enforced in the endpoint resolvers).
 */
(function () {
	"use strict";

	var rootEl = document.getElementById("ncweb-root");
	if (!rootEl) return;

	var mountpointName = rootEl.getAttribute("data-mountpoint"); // Web view id (URL/API)
	var mountpointDisplayName = rootEl.getAttribute("data-mountpoint-name") || mountpointName;

	// API endpoints per route (see the header). Fallback = the web view variant.
	var NC_API = "pit_erpnext.scripts.nc_public_web.";
	var EP_LIST = rootEl.getAttribute("data-list-method") || NC_API + "nc_web_view.nc_web_list";
	var EP_PREVIEW = rootEl.getAttribute("data-preview-method") || NC_API + "nc_web_view.nc_web_preview";
	var EP_THUMB = rootEl.getAttribute("data-thumb-method") || NC_API + "nc_web_view.nc_web_thumb";
	// Display-only sort prefix (Nextcloud Mountpoint / Nextcloud Location): a
	// JavaScript regex whose match is hidden in the DISPLAYED folder name. The
	// real name stays the sort key, the route and the download path, so nothing
	// is renamed in Nextcloud (Gerald, 2026-10). Empty = feature off.
	var namePrefixPattern = (rootEl.getAttribute("data-name-prefix-pattern") || "").trim();
	var namePrefixRe = null;
	if (namePrefixPattern) {
		try {
			namePrefixRe = new RegExp(namePrefixPattern);
		} catch (err) {
			// An invalid pattern must never break the listing.
			namePrefixRe = null;
		}
	}

	// Label of one entry: FOLDERS lose the sort prefix, files keep their name.
	// Never render an empty label - a folder named just "01_" keeps its name.
	function displayName(entry) {
		var name = (entry && entry.name) || "";
		if (!namePrefixRe || !entry || !entry.is_dir) return name;
		var stripped = name.replace(namePrefixRe, "").trim();
		return stripped || name;
	}

	// Search text of one entry: the REAL and the DISPLAYED name, so a query for
	// "01" still finds a folder that is shown without its prefix.
	function searchText(entry) {
		var name = (entry && entry.name) || "";
		var shown = displayName(entry);
		return shown === name ? name : name + " " + shown;
	}


	// Server-side translations (website pages don't populate frappe.boot._messages
	// with app strings). Read the JSON handed over by get_context.
	var I18N = {};
	try {
		var raw = rootEl.getAttribute("data-i18n");
		if (raw) I18N = JSON.parse(raw);
	} catch (e) { I18N = {}; }

	// Translate a string: prefer server-side map, fall back to Frappe's __().
	function t(src) {
		if (I18N[src]) return I18N[src];
		if (typeof __ === "function") return __(src);
		return src;
	}
	// Load the app's primary color via the pit_erpnext API (the theme CSS is not
	// loaded on website pages) and expose it as --ncweb-primary on the root.
	(function () {
		fetch(curl() + "pit_erpnext.api.colors.get_colors_flat", { credentials: "same-origin" })
			.then(function (r) { return r.json(); })
			.then(function (res) {
				// Whitelisted APIs wrap the dict: res.message = {message: {...}}
				var inner = (res && res.message) || {};
				if (inner && inner.message && typeof inner.message === "object") inner = inner.message;
				var c = inner.primary_light || inner.primary_dark || null;
				if (c) {
					rootEl.style.setProperty("--ncweb-primary", c);
					// Dialogs are appended to <body> (outside #ncweb-root), so
					// the CI colour must also live on :root to reach them.
					document.documentElement.style.setProperty("--ncweb-primary", c);
				}
			})
			.catch(function () { /* keep CSS fallback */ });
	})();

	// Path within the view (relative to the access point). Read from the URL.
	var currentRoute = "";

	var FRAPPE_CALL = "/api/method/";

	function el(tag, cls, text) {
		var e = document.createElement(tag);
		if (cls) e.className = cls;
		if (text !== undefined && text !== null) e.textContent = text;
		return e;
	}

	function fmtSize(bytes) {
		if (bytes === null || bytes === undefined) return "";
		var n = Number(bytes);
		if (isNaN(n)) return "";
		if (n === 0) return "0 KB";
		if (n < 1024) return "< 1 KB";
		if (n < 1024 * 1024) return (n / 1024).toFixed(1) + " KB";
		if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + " MB";
		return (n / 1024 / 1024 / 1024).toFixed(2) + " GB";
	}

	function getLocale() {
		// Use the Frappe user language (boot) or the page <html lang> attribute
		// when available; falls back to the browser language.
		try {
			if (window.frappe && frappe.boot && frappe.boot.lang) {
				var l = String(frappe.boot.lang).replace("_", "-");
				if (l) return l;
			}
		} catch (e) { /* ignore */ }
		try {
			var hlang = document.documentElement.getAttribute("lang");
			if (hlang) return hlang;
		} catch (e) { /* ignore */ }
		try {
			if (navigator.language) return navigator.language;
		} catch (e) { /* ignore */ }
		return "en";
	}

	var RELATIVE_LOCALE = getLocale();
	var RELATIVE_FMT = new Intl.RelativeTimeFormat(RELATIVE_LOCALE, { numeric: "auto" });

	function absoluteTime(iso) {
		if (!iso) return "";
		var d = new Date(iso);
		if (isNaN(d.getTime())) return "";
		// Tooltip: exact "hh:mm:ss day. month. year"
		return d.toLocaleTimeString(RELATIVE_LOCALE, { hour: "2-digit", minute: "2-digit", second: "2-digit" })
			+ " " + d.toLocaleDateString(RELATIVE_LOCALE, { day: "2-digit", month: "2-digit", year: "numeric" });
	}

	function fmtModified(iso) {
		if (!iso) return "";
		var d = new Date(iso);
		if (isNaN(d.getTime())) return "";
		var now = new Date();
		var diffMs = now.getTime() - d.getTime();
		if (diffMs < 0) diffMs = 0;
		var diffSec = Math.floor(diffMs / 1000);
		var diffMin = Math.floor(diffSec / 60);
		var diffHours = Math.floor(diffMin / 60);
		var diffDays = Math.floor(diffHours / 24);
		var diffWeeks = Math.floor(diffDays / 7);

		if (diffSec < 60) {
			// a few seconds ago
			return RELATIVE_FMT.format(-0, "second");
		}
		if (diffMin < 60) {
			return RELATIVE_FMT.format(-diffMin, "minute");
		}
		if (diffHours < 24) {
			return RELATIVE_FMT.format(-diffHours, "hour");
		}
		if (diffDays < 7) {
			return RELATIVE_FMT.format(-diffDays, "day");
		}
		if (diffWeeks < 4) {
			return RELATIVE_FMT.format(-diffWeeks, "week");
		}
		// >= 4 weeks: "day month" (month long form); other year: "day month year"
		var sameYear = d.getFullYear() === now.getFullYear();
		if (sameYear) {
			return d.toLocaleDateString(RELATIVE_LOCALE, { day: "numeric", month: "long" });
		}
		return d.toLocaleDateString(RELATIVE_LOCALE, { day: "numeric", month: "numeric", year: "numeric" });
	}

	function svgEl(pathData, fillColor, viewBox) {
		// Create an inline SVG element (MDI paths, Nextcloud-style icons).
		var NS = "http://www.w3.org/2000/svg";
		var svg = document.createElementNS(NS, "svg");
		svg.setAttribute("viewBox", viewBox || "0 0 24 24");
		svg.setAttribute("width", "24");
		svg.setAttribute("height", "24");
		svg.setAttribute("fill", fillColor || "currentColor");
		var path = document.createElementNS(NS, "path");
		path.setAttribute("d", pathData);
		svg.appendChild(path);
		return svg;
	}

	// MDI icon paths (Nextcloud file type colors).
	var ICON_DOTS = "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z";
	// Toolbar icons (breadcrumb bar, right side).
	var ICON_SEARCH = "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z";
	var ICON_LIST = "M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z";
	var ICON_GRID = "M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3H13";
	var ICON_HOME = "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z";
	var ICON_FOLDER = "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z";
	var ICON_DOC = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z";
	var ICON_SHEET = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M9 18H6V16H9V18M9 15H6V13H9V15M9 12H6V10H9V12M13 18H10V16H13V18M13 15H10V13H13V15M13 12H10V10H13V12Z";
	var ICON_PRES = "M19,16H5V8H19M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
	var ICON_PDF = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z";
	var ICON_AUDIO = "M21,3V15.5A3.5,3.5 0 0,1 17.5,19A3.5,3.5 0 0,1 14,15.5A3.5,3.5 0 0,1 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5A3.5,3.5 0 0,1 5.5,21A3.5,3.5 0 0,1 2,17.5A3.5,3.5 0 0,1 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z";
	var ICON_IMAGE = "M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z";
	var ICON_VIDEO = "M18,4L20,8H17L15,4H13L15,8H12L10,4H8L10,8H7L5,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V4H18Z";
	var ICON_FILE = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z";

	// Extension -> [icon path, fill color] (Nextcloud file type colors).
	var EXT_ICONS = {
		pdf: [ICON_PDF, "#dc5047"],
		doc: [ICON_DOC, "#49abea"], docx: [ICON_DOC, "#49abea"],
		odt: [ICON_DOC, "#49abea"], rtf: [ICON_DOC, "#49abea"], txt: [ICON_DOC, "#49abea"], md: [ICON_DOC, "#49abea"],
		xls: [ICON_SHEET, "#9abd4e"], xlsx: [ICON_SHEET, "#9abd4e"], ods: [ICON_SHEET, "#9abd4e"], csv: [ICON_SHEET, "#9abd4e"],
		ppt: [ICON_PRES, "#f0965f"], pptx: [ICON_PRES, "#f0965f"], odp: [ICON_PRES, "#f0965f"],
		mp3: [ICON_AUDIO, "#6f6f6f"], wav: [ICON_AUDIO, "#6f6f6f"], ogg: [ICON_AUDIO, "#6f6f6f"], flac: [ICON_AUDIO, "#6f6f6f"],
		png: [ICON_IMAGE, "#6f6f6f"], jpg: [ICON_IMAGE, "#6f6f6f"], jpeg: [ICON_IMAGE, "#6f6f6f"],
		gif: [ICON_IMAGE, "#6f6f6f"], svg: [ICON_IMAGE, "#6f6f6f"], webp: [ICON_IMAGE, "#6f6f6f"],
		mp4: [ICON_VIDEO, "#6f6f6f"], mov: [ICON_VIDEO, "#6f6f6f"], avi: [ICON_VIDEO, "#6f6f6f"], mkv: [ICON_VIDEO, "#6f6f6f"],
		zip: [ICON_FILE, "#6f6f6f"], rar: [ICON_FILE, "#6f6f6f"], "7z": [ICON_FILE, "#6f6f6f"]
	};

	function iconFor(isDir, name) {
		// File type icon as inline SVG (Nextcloud-style colors, 24px).
		// Folders use the app's primary color via CSS (--primary-color).
		var svg;
		if (isDir) {
			svg = svgEl(ICON_FOLDER, null);
			svg.classList.add("ncweb-icon-folder");
		} else {
			var ext = (name || "").split(".").pop().toLowerCase();
			var match = EXT_ICONS[ext] || [ICON_FILE, "#6f6f6f"];
			svg = svgEl(match[0], match[1]);
		}
		svg.classList.add("ncweb-icon-svg");
		return svg;
	}

	function setMessage(text, isError) {
		var msg = document.getElementById("ncweb-message");
		if (!msg) return;
		if (text) {
			msg.textContent = text;
			msg.style.display = "block";
			msg.className = "ncweb-message" + (isError ? " ncweb-message-error" : "");
		} else {
			msg.style.display = "none";
		}
	}

	function crumbButton(label, onClick) {
		// Nextcloud-style breadcrumb button (pill with hover background).
		var btn = el("button", "ncweb-crumb", label);
		btn.type = "button";
		btn.addEventListener("click", function (e) {
			e.preventDefault();
			onClick();
		});
		return btn;
	}

	function crumbSeparator() {
		var sep = el("span", "ncweb-crumb-sep");
		sep.appendChild(svgEl("M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z", "currentColor"));
		sep.querySelector("svg").classList.add("ncweb-crumb-sep-svg");
		return sep;
	}

	function makeCrumb(path, label) {
		return crumbButton(label, function () {
			currentRoute = path;
			load(true);
		});
	}

	function updateBreadcrumb() {
		var bc = document.getElementById("ncweb-breadcrumb");
		if (!bc) return;
		bc.textContent = "";
		// Root (mountpoint): on narrow screens a HOME ICON replaces the
		// mountpoint-name crumb (CSS shows/hides via media query; the click
		// always navigates to the root). The name must live in its own <span>
		// (crumbButton would render it as a bare text node that CSS cannot
		// target), so the root button is built explicitly here.
		var rootBtn = crumbButton(mountpointDisplayName, function () {
			currentRoute = "";
			load(true);
		});
		rootBtn.classList.add("ncweb-crumb-root");
		// Wrap the button's text node in a span so the compact CSS can hide
		// it. Single step: the text node is the ONLY child at this point —
		// a while-loop here re-appends the span it just created and hangs
		// the page in an infinite loop (shipped once).
		if (rootBtn.firstChild) {
			var nameNode = rootBtn.removeChild(rootBtn.firstChild);
			var nameSpan = el("span", "ncweb-crumb-name-text");
			nameSpan.appendChild(nameNode);
			rootBtn.appendChild(nameSpan);
		}
		var homeSvg = svgEl(ICON_HOME, "currentColor");
		homeSvg.classList.add("ncweb-crumb-home-svg");
		rootBtn.appendChild(homeSvg);
		bc.appendChild(rootBtn);
		if (!currentRoute) return;

		var parts = currentRoute.split("/").filter(Boolean);
		var n = parts.length;

		// Render ALL crumbs first (full available width); collapse only when
		// the bar actually overflows. Collapsing starts from the middle.
		var refs = [];
		parts.forEach(function (p, i) {
			var path = parts.slice(0, i + 1).join("/");
			var sep = crumbSeparator();
			// Same display name as the listing: a folder's sort prefix is
			// hidden here too (the route keeps the real name).
			var label = displayName({ name: p, is_dir: true });
			var btn = makeCrumb(path, label);
			if (i === n - 1) btn.classList.add("ncweb-crumb-current"); // current folder
			refs.push({ index: i, label: label, path: path, btn: btn, sep: sep });
			bc.appendChild(sep);
			bc.appendChild(btn);
		});

		// Collapse priority: middle segments first, then first-after-root,
		// then the direct parent (last resort). Root + current stay always.
		function prio(i) {
			if (i === 0 || i === n - 1) return 100;     // never collapsed
			if (i === n - 2) return 30;                 // parent: last resort
			if (i === 1) return 20;                     // first after root
			return 10;                                  // middle first
		}

		var hidden = [];
		function hideRef(r) {
			r.btn.style.display = "none";
			r.sep.style.display = "none";
			hidden.push(r);
		}
		function overflowing() {
			// Sum of visible children widths + gaps vs. container width. This is
			// immune to overflow:hidden clipping on the last crumb and to
			// overflow:visible on the bar (rect-based checks fail in both cases).
			var total = 0;
			var kids = bc.children;
			for (var i = 0; i < kids.length; i++) {
				if (kids[i].style && kids[i].style.display === "none") continue;
				total += kids[i].getBoundingClientRect().width;
			}
			// account for the flex gap (2px between items)
			var visibleCount = 0;
			for (var j = 0; j < kids.length; j++) {
				if (kids[j].style && kids[j].style.display !== "none") visibleCount++;
			}
			if (visibleCount > 1) total += 2 * (visibleCount - 1);
			// Measure against the HEADER content box (header right minus its right
			// padding), never against the breadcrumb"s own width: the path bar is an
			// overflow:visible flex item that grows with its content, so its own
			// width is not a fixed budget and the bar silently overruns into the
			// header padding. A small safety margin (6px) keeps the last crumb off
			// the header"s right padding edge.
			var headerEl = bc.closest(".ncweb-header") || bc.parentElement;
			var hRect = headerEl.getBoundingClientRect();
			var hStyle = getComputedStyle(headerEl);
			// Reserve the toolbar (search + view toggle) at the bar's right end
		// so crumbs never run underneath its buttons.
			var toolbarW = 0;
			var tb = headerEl.querySelector(".ncweb-toolbar");
			if (tb && tb !== bc) {
				var tbStyle = getComputedStyle(tb);
				toolbarW = tb.getBoundingClientRect().width + (parseFloat(tbStyle.marginLeft) || 0);
			}
			var budgetRight = hRect.right - (parseFloat(hStyle.paddingRight) || 0) - 6 - toolbarW;
			var budgetLeft = bc.getBoundingClientRect().left;
			var avail = Math.max(0, budgetRight - budgetLeft);
			var bySum = total > avail + 1;
			// Second guard: does the last visible child reach beyond the
			// breadcrumb bar (into the header padding)? Catches layout timing
			// issues where the sum was measured before final layout.
			var lastVisible = null;
			for (var k = kids.length - 1; k >= 0; k--) {
				if (!kids[k].style || kids[k].style.display !== "none") { lastVisible = kids[k]; break; }
			}
			var byEdge = false;
			if (lastVisible) {
				var barRect = bc.getBoundingClientRect();
				var itemRect = lastVisible.getBoundingClientRect();
				byEdge = itemRect.right > budgetRight + 1;
			}
			return bySum || byEdge;
		}

		// Reserve the "..." button UP FRONT (before measuring/collapsing) so its
		// width is always included; it is repositioned after the loop and removed
		// if nothing ends up hidden. (No own chevron here — the separator before
		// the "..." is inserted at its final position after the loop.)
		var moreBtn = el("button", "ncweb-crumb ncweb-crumb-more", "…");
		moreBtn.type = "button";
		var moreMenu = el("div", "ncweb-crumb-menu");
		moreMenu.style.display = "none";
		moreBtn.appendChild(moreMenu);
		moreBtn.addEventListener("click", function (ev) {
			ev.stopPropagation();
			ev.preventDefault();
			moreMenu.style.display = moreMenu.style.display === "none" ? "block" : "none";
		});
		// Temporary position: right after the root crumb.
		bc.insertBefore(moreBtn, bc.children[1]);

		// Collapse iterative: hide the least-priority crumb (middle-most first)
		// until everything fits. Hidden crumbs form a contiguous middle block.
		while (overflowing()) {
			var candidates = refs.filter(function (r) {
				return r.index !== n - 1 && r.btn.style.display !== "none";
			});
			if (!candidates.length) break;
			candidates.sort(function (a, b) {
				var pa = prio(a.index), pb = prio(b.index);
				if (pa !== pb) return pa - pb;
				// Equal priority: hide the one farthest from the middle first.
				var da = Math.abs(a.index - (n - 1) / 2);
				var db = Math.abs(b.index - (n - 1) / 2);
				return db - da;
			});
			hideRef(candidates[0]);
		}

		// Position the reserved "..." button at the hidden block's location.
		if (hidden.length) {
			hidden.sort(function (a, b) { return a.index - b.index; });
			var minIdx = hidden[0].index;
			var maxIdx = hidden[hidden.length - 1].index;

			// Hide any still-visible crumb within [minIdx, maxIdx] (contiguous block).
			refs.forEach(function (r) {
				if (r.index > minIdx && r.index < maxIdx && r.btn.style.display !== "none") {
					hideRef(r);
				}
			});

			// Fill the "..." dropdown with the hidden crumbs (original order).
			hidden.slice().sort(function (a, b) { return a.index - b.index; }).forEach(function (r) {
				var item = el("button", "ncweb-crumb-menu-item", r.label);
				item.type = "button";
				item.addEventListener("click", function (ev) {
					ev.preventDefault();
					moreMenu.style.display = "none";
					currentRoute = r.path;
					load(true);
				});
				moreMenu.appendChild(item);
			});

			// Move the reserved "..." button to the block position: a chevron BEFORE it
			// (the following visible crumb brings its own leading chevron after it).
			var anchor = null;
			if (maxIdx + 1 < n) anchor = refs[maxIdx + 1].sep;
			var sepBeforeMoreFinal = crumbSeparator();
			bc.insertBefore(sepBeforeMoreFinal, anchor);
			bc.insertBefore(moreBtn, anchor);
		} else {
			// Nothing hidden: remove the reserved "..." button.
			moreBtn.remove();
		}

		// Final fit pass: the repositioning above inserts one more separator
		// (~22px) that was NOT part of the measured layout in the collapse
		// loop, which can push the last crumb into the header padding. Re-run
		// the collapse with the final DOM in place.
		var guard = 0;
		while (overflowing() && guard++ < 30) {
			var late = refs.filter(function (r) {
				return r.index !== n - 1 && r.btn.style.display !== "none";
			});
			if (!late.length) break;
			late.sort(function (a, b) {
				var pa = prio(a.index), pb = prio(b.index);
				if (pa !== pb) return pa - pb;
				var da = Math.abs(a.index - (n - 1) / 2);
				var db = Math.abs(b.index - (n - 1) / 2);
				return db - da;
			});
			hideRef(late[0]);
			// keep the "..." block contiguous again
			var stillMin = null, stillMax = null;
			hidden.forEach(function (r) {
				if (stillMin === null || r.index < stillMin) stillMin = r.index;
				if (stillMax === null || r.index > stillMax) stillMax = r.index;
			});
			refs.forEach(function (r) {
				if (stillMin !== null && r.index > stillMin && r.index < stillMax && r.btn.style.display !== "none") {
					hideRef(r);
				}
			});
		}

		// Truncate the current folder name ONLY as the very last step: after
		// everything else is settled and root+current still overflow the bar.
		if (overflowing()) {
			var currentRef = refs[n - 1];
			if (currentRef) currentRef.btn.classList.add("ncweb-crumb-shrink");
		}
	}

	// Close the breadcrumb "more" menu when clicking elsewhere.
	document.addEventListener("click", function (ev) {
		document.querySelectorAll(".ncweb-crumb-menu").forEach(function (m) {
			if (!m.parentElement.contains(ev.target)) {
				m.style.display = "none";
			}
		});
	});

	// Folder description (readme.md): the backend removes the file from the
	// listing and hands over its Markdown rendered to safe HTML. Insert it
	// between breadcrumb and file list; hide when the folder has none. Links
	// open in a new tab; images join the fullscreen preview gallery.
	// One-time drag handle for the readme box: resize by pulling the bottom
	// edge toward the table header. min-height (240px) is enforced by CSS.
	var readmeResizeWired = false;
	var readmeHandleEl = null;
	function wireReadmeResize(box) {
		if (readmeResizeWired || !box) return;
		readmeResizeWired = true;
		// The handle lives OUTSIDE the scrolling readme box (in the explorer
		// card) - inside an overflow:auto element it would scroll away with
		// the content and only be grabbable at scrollTop 0 (shipped bug).
		readmeHandleEl = el("div", "ncweb-readme-resize");
		readmeHandleEl.title = "Ziehen zum Anpassen der Höhe";
		box.parentElement.appendChild(readmeHandleEl);
		syncReadmeHandle(box);
		var startY = 0, startH = 0;
		readmeHandleEl.addEventListener("mousedown", function (ev) {
			ev.preventDefault();
			startY = ev.pageY;
			startH = box.getBoundingClientRect().height;
			document.body.style.cursor = "ns-resize";
			// Lock the document scroll + text selection during the drag so the
			// page-relative delta never drifts (this made resize "stick" at the
			// fully-expanded size: scrolling changed clientY mid-drag).
			var prevOverflow = document.body.style.overflow;
			document.body.style.overflow = "hidden";
			document.body.style.userSelect = "none";
			function onMove(e2) {
				var h = startH + (e2.pageY - startY);
				var minH = parseFloat(getComputedStyle(box).minHeight) || 240;
				// The box can be pulled up only as far as its CONTENT reaches
				// (scrollHeight already includes the padding). At (or beyond)
				// that point the readme needs no scrolling, so the scrollbar
				// is hidden and the height is locked to the content height.
				var maxH = box.scrollHeight;
				if (h >= maxH - 1) {
					box.style.height = maxH + "px";
					box.style.overflowY = "hidden";
				} else {
					box.style.height = Math.max(minH, h) + "px";
					box.style.overflowY = "auto";
				}
			}
			function onUp() {
				document.removeEventListener("mousemove", onMove);
				document.removeEventListener("mouseup", onUp);
				document.body.style.overflow = prevOverflow;
				document.body.style.userSelect = "";
				document.body.style.cursor = "";
			}
			document.addEventListener("mousemove", onMove);
			document.addEventListener("mouseup", onUp);
		});
		// Keep the handle glued to the box's bottom edge on every layout change.
		new ResizeObserver(function () { syncReadmeHandle(box); }).observe(box);
	}
	function syncReadmeHandle(box) {
		if (!readmeHandleEl || !box) return;
		var r = box.getBoundingClientRect();
		var p = box.parentElement.getBoundingClientRect();
		readmeHandleEl.style.top = (r.bottom - p.top - 3) + "px";
	}

	function renderReadme(html) {
		var box = document.getElementById("ncweb-readme");
		if (!box) return;
		if (html) {
			box.innerHTML = html;
			wireReadmeResize(box);
			// Readme links open in a new tab, like external links in Nextcloud.
			box.querySelectorAll("a").forEach(function (a) {
				a.target = "_blank";
				a.rel = "noopener noreferrer";
			});
			// Clicking a readme image opens the fullscreen preview overlay and
			// lets the user step through ALL readme images (same slideshow as
			// the file list uses: arrows + left/right keys).
			var readmeImgs = Array.prototype.slice.call(box.querySelectorAll("img"));
			readmeImgs.forEach(function (img, i) {
				img.style.cursor = "pointer";
				img.addEventListener("click", function (ev) {
					ev.preventDefault();
					openReadmeGallery(readmeImgs, i);
				});
			});
			box.style.display = "block";
		} else {
			box.textContent = "";
			box.style.display = "none";
		}
	}

	// Fullscreen preview for readme images: reuse the existing overlay +
	// slideshow by loading the image URL directly (it is already a
	// session-authed ncfileviewer URL). Header title shows the image name.
	function openReadmeGallery(imgs, startIndex) {
		var mpSeg = "/ncfileviewer/" + encodeURIComponent(mountpointName) + "/";
		var list = imgs.map(function (img) {
			var src = img.getAttribute("src") || "";
			// Derive the plain route from the ncfileviewer URL so BOTH the
			// preview loader AND the header download button use the same
			// route-based code paths as list previews (drop the route prefix).
			var after = src.split("?")[0];
			if (after.indexOf(mpSeg) === 0) {
				after = after.substring(mpSeg.length);
			} else {
				after = after.replace(/^.*?\/ncfileviewer\/[^/]+\//, "");
			}
			var route = after.split("/").map(decodeURIComponent).join("/");
			var name = decodeURIComponent(src.split("?")[0].split("/").pop() || "image");
			return { path: route, url: src, name: name };
		});
		if (!list.length) return;
		openPreview(list[startIndex].path, list[startIndex].name, null, null, list, startIndex);
	}

	function render(entries, depth) {
		// Keep the original data (search + view switch re-render from it).
		lastEntries = entries || [];
		lastDepth = depth || 0;

		// Live search filter: applies to the REAL list below (both views) and
		// stays active across folder navigation until cleared. IMPORTANT: the
		// filtered array must REPLACE `entries` — renderList/renderGrid below
		// use that variable. (A previous round computed a `visible` copy but
		// never used it, so typing a query visibly changed NOTHING.)
		var visible = entries;
		if (searchQuery) {
			var sq = searchQuery.toLowerCase();
			visible = (entries || []).filter(function (e) {
				return searchText(e).toLowerCase().indexOf(sq) >= 0;
			});
			entries = visible; // <-- feed the filtered list to the renderers
			if (!visible.length) {
				// Query active but nothing matches in THIS folder: same
				// centered style as the empty-folder state, search icon above.
				var t0 = document.getElementById("ncweb-table");
				if (t0) t0.style.display = "none";
				var g0 = document.getElementById("ncweb-grid");
				if (g0) { g0.style.display = "none"; g0.textContent = ""; }
				var es0 = document.getElementById("ncweb-empty-state");
				if (es0) {
					es0.textContent = "";
					var box0 = el("div", "ncweb-empty-content");
					var ic0 = svgEl(ICON_SEARCH, "#9ca3af");
					ic0.classList.add("ncweb-empty-icon");
					box0.appendChild(ic0);
					box0.appendChild(el("div", "ncweb-empty-text", t("No search results found")));
					es0.appendChild(box0);
					es0.style.display = "block";
				}
				return;
			}
		}

		if (!entries || entries.length === 0) {
			// Empty folder: hide the table AND the grid and show only the
			// Nextcloud-style empty state (folder icon + text) under the breadcrumb.
			var table = document.getElementById("ncweb-table");
			if (table) table.style.display = "none";
			var gridEl = document.getElementById("ncweb-grid");
			if (gridEl) { gridEl.style.display = "none"; gridEl.textContent = ""; }
			var emptyState = document.getElementById("ncweb-empty-state");
			if (emptyState) {
				emptyState.textContent = "";
				var emptyBox = el("div", "ncweb-empty-content");
				var emptyIcon = svgEl("M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z", "#9ca3af");
				emptyIcon.classList.add("ncweb-empty-icon");
				emptyBox.appendChild(emptyIcon);
				emptyBox.appendChild(el("div", "ncweb-empty-text", t("No files in here")));
				emptyState.appendChild(emptyBox);
				emptyState.style.display = "block";
			}
			return;
		}

		// Non-empty folder: hide the empty-state and dispatch to the active
		// view shape (list table or grid tiles).
		var emptyState = document.getElementById("ncweb-empty-state");
		if (emptyState) emptyState.style.display = "none";

		entries = sortEntries(entries);

		if (viewMode === "grid") {
			// Keep the sortable table header visible; only the ROWS are
			// replaced by tiles (tbody empty, grid rendered below the header).
			var tbodyG = document.getElementById("ncweb-tbody");
			if (tbodyG) tbodyG.textContent = "";
			var tableG = document.getElementById("ncweb-table");
			if (tableG) tableG.style.display = "";
			// Grid container after the table.
			var gridE = document.getElementById("ncweb-grid");
			if (gridE) { gridE.textContent = ""; gridE.style.display = ""; }
			renderGrid(entries, depth);
			return;
		}
		var tbodyG2 = document.getElementById("ncweb-tbody");
		if (tbodyG2) tbodyG2.textContent = "";
		var gridE2 = document.getElementById("ncweb-grid");
		if (gridE2) gridE2.style.display = "none";
		var table2 = document.getElementById("ncweb-table");
		if (table2) table2.style.display = "";

		renderList(entries, depth);
	}

	function renderList(entries, depth) {
		var tbody = document.getElementById("ncweb-tbody");
		if (!tbody) return;
		tbody.textContent = "";

		// Depth check: 0 = full depth; N >= 1 = exactly N levels are visible
		// (1 = only the root folder's content, subfolders locked; 2 = root
		// plus one level deeper; ...). A folder at currentDepth is openable
		// when the level BELOW it (currentDepth + 1) is still within the
		// limit, i.e. currentDepth < depth - 1.
		var currentDepth = currentRoute ? currentRoute.split("/").length : 0;
		var self = this;

		entries.forEach(function (e) {
			var tr = el("tr");
			var isDir = e.is_dir;
			// The row-level open action (set below depending on type). Attached
			// to the whole <tr> at the end so the full row height/width opens
			// the content, not just the (narrow) name cell.
			var rowOpen = null;

			// Col 1: Name - the WHOLE cell (icon + text) is clickable to open the content.
					var tdName = el("td", "col-name");
					var nameCell = el("div", "ncweb-name-cell");
					var ic = iconFor(isDir, e.name);
					nameCell.appendChild(ic);

					if (isDir) {
						var canOpen = !depth || currentDepth < depth - 1;
						if (canOpen) {
							var a = el("a", "ncweb-name", displayName(e));
							a.href = "#";
							(function (path) {
								var openFolder = function (ev) {
									if (ev) ev.preventDefault();
									currentRoute = path;
									load(true);
								};
								// No own click handler on the <a>: the click bubbles to the
								// <tr> row handler, which opens once and prevents default.
								rowOpen = openFolder;
								nameCell.classList.add("ncweb-name-open");
							})(e.path);
							nameCell.appendChild(a);
						} else {
							nameCell.appendChild(el("span", "ncweb-name ncweb-name-locked", displayName(e)));
						}
						tdName.appendChild(nameCell);
					} else {
						nameCell.appendChild(el("span", "ncweb-name ncweb-name-file", displayName(e)));
						// Files: clicking the cell opens the preview.
						(function (path, nm) {
							var openFile = function (ev) {
								if (ev) ev.preventDefault();
								if (previewSupported(nm)) {
									openPreview(path, nm, e.content_type, e.size);
								} else {
									showAlert(t("Preview not supported for this file type."));
								}
							};
							// Whole-row click opens the preview (bound on <tr> below);
							// unsupported types show a small popup instead.
							rowOpen = openFile;
							nameCell.classList.add("ncweb-name-cell-clickable");
						})(e.path, e.name);
						tdName.appendChild(nameCell);
					}
					// Only the name column opens the content: bind on the <td> so
				// the whole cell (icon + name, full row height incl. padding)
				// responds, while the action/size/modified columns do not.
				if (rowOpen) {
					tdName.addEventListener("click", rowOpen);
					tdName.classList.add("ncweb-col-open");
				}
				tr.appendChild(tdName);

			// Col 2: Three-dots menu (actions dropdown)
			var tdMenu = el("td", "col-menu");
			var menuBtn = el("button", "ncweb-menu-btn");
			menuBtn.type = "button";
			menuBtn.title = t("Actions");
			var dotsSvg = svgEl(ICON_DOTS, "currentColor");
			dotsSvg.classList.add("ncweb-icon-svg");
			menuBtn.appendChild(dotsSvg);
			menuBtn.addEventListener("click", function (ev) {
				ev.stopPropagation();
				ev.preventDefault();
				toggleMenu(menuDropdown, menuBtn);
			});
			tdMenu.appendChild(menuBtn);

			var menuDropdown = el("div", "ncweb-menu-dropdown");
			menuDropdown.style.display = "none";
			// Clicks inside the dropdown (e.g. Download) must not bubble up to
			// the row-open handler.
			menuDropdown.addEventListener("click", function (ev) { ev.stopPropagation(); });
			// Download (files AND folders) via a short-lived Nextcloud share:
			// the browser is 302-redirected to the share's /download URL and
			// streams directly from Nextcloud. Folders are packed as ZIP by
			// Nextcloud; the server rejects folders containing subfolders
			// (depth-limit consistency). Navigating to an attachment response
			// never leaves the page visually.
			var dlItem = el("div", "ncweb-menu-item", t("Download"));
			(function (path) {
				dlItem.addEventListener("click", function (ev) {
					ev.preventDefault();
					closeMenu(menuDropdown, menuBtn);
					shareDownload(path);
				});
			})(e.path);
			menuDropdown.appendChild(dlItem);
			// Rename / Delete (write extension, hidden while read-only).
			extendItemMenu(menuDropdown, e, menuBtn);
			tdMenu.appendChild(menuDropdown);
			tr.appendChild(tdMenu);

			// Col 3: Size
			var tdSize = el("td", "col-size", fmtSize(e.size));
			tr.appendChild(tdSize);

			// Col 4: Modified (relative time; tooltip shows the exact timestamp)
			var tdMod = el("td", "col-modified", fmtModified(e.modified));
			var absT = absoluteTime(e.modified);
			if (absT) tdMod.title = absT;
			tr.appendChild(tdMod);

			tbody.appendChild(tr);
		});
	}

	// ----- Grid (tile) view: Nextcloud-style tiles ~150x200, big file type
	// icon (130px), name below, meta row (size · modified) with the 3-dots
	// menu on the right. Reuses the same open/preview/menu logic as the list.
	function renderGrid(entries, depth) {
		var grid = document.getElementById("ncweb-grid");
		if (!grid) return;
		grid.textContent = "";
		var currentDepth = currentRoute ? currentRoute.split("/").length : 0;

		entries.forEach(function (e) {
			var tile = el("div", "ncweb-tile");
			var isDir = e.is_dir;

			var iconWrap = el("div", "ncweb-tile-icon");
			// Videos get the plain file-type icon: Nextcloud's preview API
			// does not render video frames, so a thumbnail would always
			// fail and flash the "not found" fallback (Gerald).
			if (!isDir && isImageName(e.name)) {
				// Image tile: a small PREVIEW of the picture itself instead of
				// the file-type icon (like Nextcloud's file grid).
				var thumb = el("img", "ncweb-tile-thumb");
				thumb.alt = e.name;
				thumb.loading = "lazy";
				// Set src IMMEDIATELY to the server thumbnail URL -> the browser
				// shows the small preview as it arrives (no "not found" flash).
				thumb.src = thumbUrl(e.path);
				// If the thumbnail fails, fall back to the file-type icon.
				thumb.onerror = function () {
					if (!thumb.isConnected || iconWrap.querySelector("img")) return;
					thumb.remove();
					iconWrap.appendChild(iconFor(false, e.name));
				};
				iconWrap.appendChild(thumb);
			} else {
				iconWrap.appendChild(iconFor(isDir, e.name));
			}

			var nameDiv = el("div", "ncweb-tile-name", displayName(e));
			nameDiv.title = displayName(e);

			// Meta block: size and modified STACKED (long sizes must not push
			// modified out of view), 3-dots menu button on the right.
			var meta = el("div", "ncweb-tile-meta");
			var metaLeft = el("div", "ncweb-tile-meta-left");
			var sizeLine = el("div", "ncweb-tile-meta-line", fmtSize(e.size));
			var modLine = el("div", "ncweb-tile-meta-line", fmtModified(e.modified));
			var absT2 = absoluteTime(e.modified);
			if (absT2) modLine.title = absT2;
			metaLeft.appendChild(sizeLine);
			metaLeft.appendChild(modLine);
			meta.appendChild(metaLeft);

			var menuBtn = el("button", "ncweb-menu-btn ncweb-tile-menu-btn");
			menuBtn.type = "button";
			menuBtn.title = t("Actions");
			var dotsSvg = svgEl(ICON_DOTS, "currentColor");
			dotsSvg.classList.add("ncweb-icon-svg");
			menuBtn.appendChild(dotsSvg);

			var menuDropdown = el("div", "ncweb-menu-dropdown");
			menuDropdown.style.display = "none";
			menuDropdown.addEventListener("click", function (ev) { ev.stopPropagation(); });
			var dlItem = el("div", "ncweb-menu-item", t("Download"));
			(function (path2) {
				dlItem.addEventListener("click", function (ev) {
					ev.preventDefault();
					closeMenu(menuDropdown, menuBtn);
					shareDownload(path2);
				});
			})(e.path);
			menuDropdown.appendChild(dlItem);
			// Rename / Delete (write extension, hidden while read-only).
			extendItemMenu(menuDropdown, e, menuBtn);
			menuBtn.appendChild(menuDropdown);
			menuBtn.addEventListener("click", function (ev) {
				ev.stopPropagation();
				ev.preventDefault();
				toggleMenu(menuDropdown, menuBtn);
			});
			meta.appendChild(menuBtn);

			tile.appendChild(iconWrap);
			tile.appendChild(nameDiv);
			tile.appendChild(meta);

			// Open on click (name/icon area): folder navigate, file preview.
			(function (entry, d) {
				var canOpen = !entry.is_dir || !d || currentDepth < d - 1;
				var activate = function (ev) {
					if (ev) ev.preventDefault();
					if (entry.is_dir) {
						if (!canOpen) return;
						currentRoute = entry.path;
						load(true);
					} else if (previewSupported(entry.name)) {
						openPreview(entry.path, entry.name, entry.content_type, entry.size);
					} else {
						showAlert(t("Preview not supported for this file type."));
					}
				};
				tile.addEventListener("click", activate);
				if (canOpen) tile.classList.add("ncweb-tile-open");
			})(e, depth);

			grid.appendChild(tile);
		});
	}

	// ----- Toolbar (breadcrumb bar, right side): search button + view toggle.
	// The toggle shows the icon of the view you can SWITCH TO (list active ->
	// grid icon, grid active -> list icon). Only one view is visible at a time.
	function buildToolbar() {
		var headerEl = document.querySelector("#ncweb-breadcrumb").closest(".ncweb-header");
		if (!headerEl) return;

		var bar = el("div", "ncweb-toolbar");

		// Search button + popup.
		var searchBtn = el("button", "ncweb-toolbar-btn");
		searchBtn.type = "button";
		searchBtn.title = t("Search");
		searchBtn.setAttribute("aria-label", t("Search"));
		var searchSvg = svgEl(ICON_SEARCH, "currentColor");
		searchSvg.classList.add("ncweb-toolbar-svg");
		searchBtn.appendChild(searchSvg);

		var popup = el("div", "ncweb-search-popup");
		popup.style.display = "none";
		var input = el("input", "ncweb-search-input");
		input.type = "text";
		input.placeholder = t("Search");
		// Clear button (X) inside the input row: shown while the query is
		// non-empty, wipes the query and re-renders the unfiltered list.
		var clearBtn = el("button", "ncweb-search-clear");
		searchInputEl = input;
		searchClearEl = clearBtn;
		clearBtn.type = "button";
		clearBtn.title = t("Clear search");
		clearBtn.setAttribute("aria-label", t("Clear search"));
		clearBtn.textContent = "×";
		clearBtn.style.display = "none";
		// X sits INSIDE the search field (absolute, right edge).
		var inputWrap = el("div", "ncweb-search-input-wrap");
		inputWrap.appendChild(input);
		inputWrap.appendChild(clearBtn);
		popup.appendChild(inputWrap);

		function syncClear() {
			clearBtn.style.display = input.value ? "inline-flex" : "none";
		}

		// X: wipe the query + input and re-render the UNFILTERED real list.
		clearBtn.addEventListener("click", function (ev) {
			ev.stopPropagation();
			ev.preventDefault();
			input.value = "";
			searchQuery = "";
			syncClear();
			syncActiveState();
			if (lastEntries.length) render(lastEntries, lastDepth);
			input.focus();
		});

		// The search button shows the ACTIVE state while a query is set
		// (also when the popup itself is closed).
		function syncActiveState() {
			searchBtn.classList.toggle("ncweb-search-active", !!searchQuery);
		}
		syncActiveState();

		// The popup is ONLY the input field: the real, filtered list is the
		// table/grid BELOW (render() applies searchQuery). No dropdown here.
		function runSearch() {
			var q = input.value.trim();
			searchQuery = q; // persists across folder navigation
			syncClear();
			syncActiveState();
			// Re-render the real list with the filter applied (or unfiltered
			// when the query was emptied).
			if (lastEntries.length) render(lastEntries, lastDepth);
		}
		input.addEventListener("input", runSearch);
		input.addEventListener("keydown", function (ev) {
			if (ev.key === "Escape") {
				popup.style.display = "none";
				syncActiveState();
			}
		});
		searchBtn.addEventListener("click", function (ev) {
			ev.stopPropagation();
			ev.preventDefault();
			var show = popup.style.display === "none";
			popup.style.display = show ? "block" : "none";
			// The icon color reflects an ACTIVE QUERY ONLY (not the popup
			// being open) - syncActiveState() owns the coloring.
			syncActiveState();
			if (show) {
				// Restore the PERSISTED query (it stays active across folder
				// navigation until cleared via the X button).
				input.value = searchQuery;
				syncClear();
				input.focus();
			}
		});
		popup.addEventListener("click", function (ev) { ev.stopPropagation(); });
		document.addEventListener("click", function (ev) {
			if (!popup.contains(ev.target) && ev.target !== searchBtn && !searchBtn.contains(ev.target)) {
				popup.style.display = "none";
				syncActiveState();
			}
		});

		// View toggle button (icon = the view you switch TO).
		var viewBtn = el("button", "ncweb-toolbar-btn");
		viewBtn.type = "button";
		function syncToggleIcon() {
			viewBtn.textContent = "";
			var toGrid = viewMode === "list";
			var svg = svgEl(toGrid ? ICON_GRID : ICON_LIST, "currentColor");
			svg.classList.add("ncweb-toolbar-svg");
			viewBtn.appendChild(svg);
			viewBtn.title = toGrid ? t("Grid view") : t("List view");
			viewBtn.setAttribute("aria-label", viewBtn.title);
		}
		viewBtn.addEventListener("click", function (ev) {
			ev.preventDefault();
			viewMode = viewMode === "list" ? "grid" : "list";
			storeViewMode(viewMode);
			syncToggleIcon();
			if (lastEntries.length) render(lastEntries, lastDepth);
		});
		syncToggleIcon();

		bar.appendChild(searchBtn);
		bar.appendChild(popup);
		bar.appendChild(viewBtn);
		headerEl.appendChild(bar);
	}

	// The dropdown's own display value is the SINGLE source of truth for
	// "is this menu open". Every close path - a menu item (Download),
	// rename/delete in the write extension, a click anywhere else - only sets
	// style.display. A separate open flag next to it went stale, so after
	// closing a menu through a menu item the next click on the three dots was
	// swallowed and the menu opened only on the SECOND click (Gerald,
	// 2026-10-22). Read the DOM instead of tracking state twice.
	function toggleMenu(dropdown, btn) {
		var isOpen = dropdown.style.display === "block";
		// close all other menus first
		document.querySelectorAll(".ncweb-menu-dropdown").forEach(function (d) {
			d.style.display = "none";
		});
		dropdown.style.display = isOpen ? "none" : "block";
	}

	function closeMenu(dropdown, btn) {
		dropdown.style.display = "none";
	}

	// Extra entry actions (Rename / Delete) come from the write extension
	// (nextcloud_location_upload.js): it owns the dialogs and the write
	// endpoints, this file only owns the menu and the entry data. The
	// extension decides (via NCWeb.isReadOnly) whether the items appear -
	// the read-only state is the single guard gate for every write action.
	// A missing extension is silently tolerated (the view must never break).
	function extendItemMenu(dropdown, entry, btn) {
		if (!(window.NCWebUpload && window.NCWebUpload.extendItemMenu)) return;
		try {
			window.NCWebUpload.extendItemMenu(dropdown, entry, btn);
		} catch (e) { /* never break the listing */ }
	}

	// Close any open menu when clicking elsewhere in the document.
	document.addEventListener("click", function (ev) {
		if (!ev.target.closest(".ncweb-menu-btn")) {
			document.querySelectorAll(".ncweb-menu-dropdown").forEach(function (d) {
				d.style.display = "none";
			});
		}
	});

	// Sorting: default is name descending (like requested). Clicking a header
	// button toggles the direction for that column.
	var ICON_ARROW_UP = "M7,15L12,10L17,15H7Z"; // MDI triangle (points up by default)
	var sortKey = "name";
	var sortDir = "asc"; // "asc" | "desc" — default: name ascending (A→Z)
	var lastEntries = [];
	var lastDepth = 0; // depth of the listing currently rendered

	// View mode: "list" (default) or "grid". The toolbar toggle switches
	// between both; the button always shows the OTHER view's icon.
	// The choice is REMEMBERED per browser (Gerald, 2026-10): it is stored in
	// localStorage, so the next visit starts in the view last used. Private
	// mode / blocked storage must never break the page -> try/catch.
	var VIEW_MODE_KEY = "ncweb_view_mode";
	function storeViewMode(mode) {
		try {
			window.localStorage.setItem(VIEW_MODE_KEY, mode);
		} catch (e) {
			/* storage unavailable - the view still works, it just is not remembered */
		}
	}
	function storedViewMode() {
		try {
			var v = window.localStorage.getItem(VIEW_MODE_KEY);
			return v === "grid" || v === "list" ? v : "list";
		} catch (e) {
			return "list";
		}
	}
	var viewMode = storedViewMode();

	// Live search: non-empty query filters the REAL list (both views).
	// Reset on folder navigation (Gerald: the filter does NOT persist).
	var searchQuery = "";
	// References set by buildToolbar() so load() can reset the search UI.
	var searchInputEl = null;
	var searchClearEl = null;

	// Effective write rights of the folder currently being listed (comes with
	// every list response: the server resolves the Write Grant table of the
	// location, Gerald 2026-10). "upload" covers file upload AND folder
	// creation; the upload extension (nextcloud_location_upload.js) gates its
	// "New" controls, the row/tile menu gates Rename / Delete on this.
	var rights = { upload: false, rename: false, delete: false };
	// Compatibility flag for the "New" controls: they only make sense when
	// files may be uploaded (which includes creating folders).
	var readOnly = true;
	// Sanitizing rules of the server (max length, forbidden characters) so the
	// client cleans names exactly like nc_connection.nc_clean_item_name does.
	var nameRules = null;
	// Upload limit of the mountpoint in MB (Nextcloud Mountpoint -> max_upload_size).
	var maxUploadMb = 0;

	// Entries as currently DISPLAYED (applies the live search filter).
	// Used by e.g. the image slideshow so only filtered pictures are shown.
	function visibleEntries() {
		if (!searchQuery) return lastEntries || [];
		var sq = searchQuery.toLowerCase();
		return (lastEntries || []).filter(function (e) {
			return searchText(e).toLowerCase().indexOf(sq) >= 0;
		});
	}

	function sortEntries(list) {
		var sorted = list.slice(); // sort a copy, never mutate the backend data
		var dir = sortDir === "asc" ? 1 : -1;
		sorted.sort(function (a, b) {
			var va, vb;
			if (sortKey === "size") {
				va = a.size === null || a.size === undefined ? -1 : Number(a.size);
				vb = b.size === null || b.size === undefined ? -1 : Number(b.size);
				// Folders first within size sorting (like Nextcloud)
				if (a.is_dir !== b.is_dir) return a.is_dir ? -1 : 1;
			} else if (sortKey === "modified") {
				va = a.modified ? new Date(a.modified).getTime() : 0;
				vb = b.modified ? new Date(b.modified).getTime() : 0;
				if (a.is_dir !== b.is_dir) return a.is_dir ? -1 : 1;
			} else {
				va = (a.name || "").toLowerCase();
				vb = (b.name || "").toLowerCase();
				// Folders first within name sorting
				if (a.is_dir !== b.is_dir) return a.is_dir ? -1 : 1;
			}
			if (va < vb) return -1 * dir;
			if (va > vb) return 1 * dir;
			return 0;
		});
		return sorted;
	}

	function updateSortArrows() {
		document.querySelectorAll(".ncweb-sort-arrow").forEach(function (arrowEl) {
			var key = arrowEl.getAttribute("data-arrow");
			if (key === sortKey) {
				// Show the triangle; flip it (upside down) when descending.
				arrowEl.innerHTML = "";
				var svg = svgEl(ICON_ARROW_UP, "currentColor");
				svg.classList.add("ncweb-sort-arrow-svg");
				if (sortDir === "desc") {
					svg.style.transform = "rotate(180deg)";
				}
				arrowEl.appendChild(svg);
				arrowEl.parentElement.classList.add("ncweb-sort-active");
			} else {
				arrowEl.innerHTML = "";
				arrowEl.parentElement.classList.remove("ncweb-sort-active");
			}
		});
	}

	function setupSortHandlers() {
		document.querySelectorAll(".ncweb-sort-btn").forEach(function (btn) {
			btn.addEventListener("click", function (ev) {
				ev.preventDefault();
				var key = btn.getAttribute("data-sort");
				if (key === sortKey) {
					// Toggle direction
					sortDir = sortDir === "asc" ? "desc" : "asc";
				} else {
					sortKey = key;
					sortDir = "asc";
				}
				updateSortArrows();
				if (lastEntries.length) {
					// render() always sorts itself; hand over the raw data (keep the
					// current depth so the grid's depth-lock logic stays correct).
					render(lastEntries, lastDepth);
				}
			});
		});
	}

	function load(pushHistory) {
		setMessage(null);
		updateBreadcrumb();
		resetImageBlobCache();

		// Reset the search on navigation: the query applies to ONE folder
		// listing only (Gerald) - clear state + UI when a new folder loads.
		if (searchQuery) {
			searchQuery = "";
			if (searchInputEl) searchInputEl.value = "";
			if (searchClearEl) searchClearEl.style.display = "none";
			var activeSearchBtn = document.querySelector(".ncweb-toolbar-btn.ncweb-search-active");
			if (activeSearchBtn) activeSearchBtn.classList.remove("ncweb-search-active");
		}

		// Reset table/empty-state visibility (a new load always shows the table
		// again; the empty-state is only re-shown if the folder is really empty).
		// The grid is cleared IMMEDIATELY so tiles of the previous folder never
		// linger while the new folder is loading.
		try {
			var tbl = document.getElementById("ncweb-table");
			if (tbl) tbl.style.display = "";
			var es = document.getElementById("ncweb-empty-state");
			if (es) { es.style.display = "none"; es.textContent = ""; }
			var gridR = document.getElementById("ncweb-grid");
			if (gridR) { gridR.style.display = "none"; gridR.textContent = ""; }
		} catch (e) { /* ignore */ }

		var tbody = document.getElementById("ncweb-tbody");
		if (tbody) {
			tbody.textContent = "";
			var tr = el("tr");
			var td = el("td", "ncweb-loading");
			td.colSpan = 4;
			// Spinner (CSS animation) instead of a static text.
			var spin = el("span", "ncweb-spinner");
			td.appendChild(spin);
			tr.appendChild(td);
			tbody.appendChild(tr);
		}

		// Hide any previous folder description while the new folder loads.
		renderReadme(null);

		// URL update (history) for shareability: keep the route in a query param
		// (?folder=...) so deep links and back/forward never hit a 404 page.
		// pushHistory=true (user navigation) pushes a new history entry; popstate
		// and the initial load use replaceState to avoid duplicate entries.
		try {
			var qs = currentRoute ? "?folder=" + encodeURIComponent(currentRoute) : "";
			var basePath = (window.location.pathname.indexOf("/nextcloud-location/") === 0
				? "/nextcloud-location/" : "/nextcloud/") + encodeURIComponent(mountpointName);
			if (pushHistory) {
				history.pushState({ ncwebRoute: currentRoute }, "", basePath + qs);
			} else {
				history.replaceState({ ncwebRoute: currentRoute }, "", basePath + qs);
			}
		} catch (e) { /* ignore */ }

		var form = new URLSearchParams();
		form.set("view_id", mountpointName);
		form.set("route", currentRoute || "");
		fetch(curl() + EP_LIST, {
			method: "POST",
			credentials: "same-origin",
			headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", "X-Frappe-CSRF-Token": csrf() },
			body: form.toString()
		}).then(function (r) { return r.json(); }).then(function (res) {
			if (res && res.message && res.message.entries) {
				// The write state must be current BEFORE the rows are built:
				// the row/tile menu asks for it while rendering (rename /
				// delete items, Gerald 2026-10). The listing endpoint is the
				// one source of that state - the "New" button of the write
				// extension is synced right after via onFolderLoaded.
				// `rights` is the per-folder state (Write Grant table of the
				// location); the flag only drives the "New" controls.
				rights = res.message.rights
					|| { upload: !res.message.read_only, rename: !res.message.read_only, delete: !res.message.read_only };
				readOnly = !rights.upload;
				render(res.message.entries, res.message.depth || 0);
				// Name rules of the server sanitizer (single source of truth) and
				// the write state are handed to the upload extension.
				nameRules = res.message.name_rules || nameRules;
				maxUploadMb = res.message.max_upload_mb || 0;
				if (window.NCWebUpload && window.NCWebUpload.onFolderLoaded) {
					try {
						window.NCWebUpload.onFolderLoaded({
							read_only: readOnly,
							route: currentRoute,
							name_rules: nameRules,
							max_upload_mb: maxUploadMb
						});
					} catch (e) { /* the extension must never break the listing */ }
				}
				// Folder description from the backend (readme.md, already
				// rendered server-side; null when the folder has none).
				renderReadme(res.message.readme_html || null);
			} else if (res && res.exc) {
				setMessage(exceptionMessage(res), true);
			} else {
				setMessage(t("Unexpected response"), true);
			}
		}).catch(function (err) {
			setMessage(t("Error while loading") + ": " + err, true);
		});
	}

	function download(path, name) {
		// Download via the /ncfileviewer route (shareDownload() probes the
		// server first — rejected folder ZIPs surface as a Frappe alert on
		// this page). The renderer decides the delivery: small files are
		// streamed with `Content-Disposition: attachment` + the REAL name
		// (forced download, page stays open); big files answer with a 302
		// to the Nextcloud origin share URL (CDN bypass) so the browser
		// streams directly from Nextcloud. Access is enforced by the
		// renderer before anything is delivered.
		shareDownload(path);
	}

	// Renders a .docx file in the preview overlay with the self-hosted
	// docx-preview library (read-only by design). The vendor scripts are
	// injected ON DEMAND at the first docx preview of the session — normal
	// browsing never downloads them (Gerald: assets only in the mediacenter,
	// only when needed). Loading is shared/global so repeated previews reuse
	// the already-loaded scripts.
	var _docxLibPromise = null;
	function loadDocxPreviewLib() {
		if (_docxLibPromise) return _docxLibPromise;
		_docxLibPromise = new Promise(function (resolve, reject) {
			// jszip first (docx-preview's UMD factory requires it), then the
			// renderer itself. Each <script> resolves only on onload.
			function inject(src, onload) {
				var s = document.createElement("script");
				s.src = src;
				s.async = false;
				s.onload = onload;
				s.onerror = function () {
					// Allow a retry on the next preview attempt.
					_docxLibPromise = null;
					reject(new Error("vendor script failed: " + src));
				};
				document.head.appendChild(s);
			}
			inject("/assets/pit_erpnext/js/nextcloud/vendor/jszip.min.js", function () {
				inject("/assets/pit_erpnext/js/nextcloud/vendor/docx-preview.min.js", resolve);
			});
		});
		return _docxLibPromise;
	}

	// Renders the docx blob into the preview overlay body.
	function renderDocxPreview(path, name) {
		var body = document.getElementById("ncweb-preview-body");
		if (!body) return;
		body.appendChild(previewLoading());
		loadDocxPreviewLib()
			.then(function () {
				return fetch(previewUrl(path), { credentials: "same-origin" })
					.then(function (r) {
						if (!r.ok) throw new Error(r.status);
						return r.blob();
					});
			})
			.then(function (blob) {
				var body2 = document.getElementById("ncweb-preview-body");
				if (!body2) return; // overlay was closed while loading
				var loading = body2.querySelector(".ncweb-preview-text-loading");
				if (loading) loading.remove();
				// Container must exist BEFORE renderAsync: the library
				// resolves section styles against its parent element.
				var box = el("div", "ncweb-preview-docx");
				body2.appendChild(box);
				return window.docx.renderAsync(blob, box, null, {
					inWrapper: true,
					ignoreWidth: false,
					ignoreHeight: true,
					breakPages: true,
					ignoreFonts: false
				});
			})
			.catch(function (err) {
				var body3 = document.getElementById("ncweb-preview-body");
				if (!body3) return; // overlay closed meanwhile
				var loading3 = body3.querySelector(".ncweb-preview-text-loading");
				if (loading3) loading3.remove();
				if (body3.querySelector(".ncweb-preview-docx")) {
					return; // container exists, render error after partial paint
				}
				body3.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
			});
	}

	// Renders a .xlsx/.xlsm/.csv file in the preview overlay with the
	// self-hosted Univer spreadsheet engine + LuckyExcel adapter (read-only
	// viewer mode: full cell styling, number formats, merged cells, formulas
	// displayed as calculated values). The bundle is ~3.4 MB gzipped, so the
	// script+css inject ON DEMAND at the first spreadsheet preview of the
	// session — normal browsing never downloads them (same lazy pattern as
	// docx above). The promise dedupes; onerror resets it for a retry.
	var _xlsxLibPromise = null;
	// Hashed vendor filenames (content-hash suffix): /assets/* is served with
	// a 1-year max-age, so a rebuilt bundle under the SAME name would keep
	// serving the old version to returning browsers (Gerald asset-cache rule).
	var _XLSX_JS = "/assets/pit_erpnext/js/nextcloud/vendor/univer/univer-view-011f9d8e.js";
	var _XLSX_CSS = "/assets/pit_erpnext/js/nextcloud/vendor/univer/univer-view-3f62a680.css";
	function loadXlsxLib() {
		if (_xlsxLibPromise) return _xlsxLibPromise;
		_xlsxLibPromise = new Promise(function (resolve, reject) {
			var css = document.createElement("link");
			css.rel = "stylesheet";
			css.href = _XLSX_CSS;
			document.head.appendChild(css);
			function inject(src, onload) {
				var s = document.createElement("script");
				s.src = src;
				s.async = false;
				s.onload = onload;
				s.onerror = function () {
					// Allow a retry on the next preview attempt.
					_xlsxLibPromise = null;
					reject(new Error("vendor script failed: " + src));
				};
				document.head.appendChild(s);
			}
			inject(_XLSX_JS, function () {
				if (window.NCUniverViewLib) resolve();
				else reject(new Error("NCUniverViewLib missing after load"));
			});
		});
		return _xlsxLibPromise;
	}

	// Renders the spreadsheet blob into the preview overlay body.
	function renderXlsxPreview(path, name) {
		var body = document.getElementById("ncweb-preview-body");
		if (!body) return;
		body.appendChild(previewLoading());
		loadXlsxLib()
			.then(function () {
				return fetch(previewUrl(path), { credentials: "same-origin" })
					.then(function (r) {
						if (!r.ok) throw new Error(r.status);
						return r.arrayBuffer();
					});
			})
			.then(function (buf) {
				var body2 = document.getElementById("ncweb-preview-body");
				if (!body2) return; // overlay was closed while loading
				var loading = body2.querySelector(".ncweb-preview-text-loading");
				if (loading) loading.remove();
				var box = el("div", "ncweb-preview-xlsx");
				body2.appendChild(box);
				return window.NCUniverViewLib.create(box, buf, name);
			})
			.catch(function (err) {
				var body3 = document.getElementById("ncweb-preview-body");
				if (!body3) return; // overlay closed meanwhile
				var loading3 = body3.querySelector(".ncweb-preview-text-loading");
				if (loading3) loading3.remove();
				if (body3.querySelector(".ncweb-preview-xlsx:not(:empty)")) {
					return; // instance rendered, later error must not clear it
				}
				body3.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
			});
	}

	// ----- Preview overlay -----
	// csv is NOT here: it renders as a formatted spreadsheet via Univer (see
	// XLSX_EXT) instead of raw text — the table look is the whole point.
	var TEXT_EXT = ["txt", "md", "json", "xml", "log", "ini", "cfg", "conf", "py", "js", "html", "css", "yml", "yaml", "sh", "bat"];
	var IMG_EXT = ["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp", "ico"];
	// Browser-native <video> formats (h264/mp4, webm, ogg).
	var VIDEO_EXT = ["mp4", "webm", "ogv", "ogg", "m4v", "mov"];
	// Word 2007+ documents: rendered client-side with docx-preview
	// (read-only by design). The vendor library loads lazily on first use.
	var DOCX_EXT = ["docx"];

	// Shown as a Frappe alert whenever a docx preview opens: the client-side
	// renderer cannot reproduce every shape/font of the original, so a
	// simplified rendering must not be read as a broken document
	// (Gerald, 2026-10-22). The string is translated server-side via
	// build_i18n_map (www/nextcloud/index.py) - keep this constant, that map
	// and translations/de.csv in sync.
	var DOCX_PREVIEW_HINT = "Preview only: some elements of the original document are not shown here. The original may differ.";
	// Spreadsheets (xlsx/xlsm/csv): rendered client-side with Univer +
	// LuckyExcel — full cell styling, number formats, merged cells, formulas
	// (read-only, viewer mode). Lazy-loaded on first use (bundle ~3.4 MB
	// gzipped, therefore NEVER bundled or preloaded). Old binary .xls is NOT
	// renderable (LuckyExcel reads OOXML zips) — stays "not supported".
	var XLSX_EXT = ["xlsx", "xlsm", "csv"];

	// Slideshow state: the images of the CURRENT folder (display order) and the
	// index of the image currently shown. Empty when not in an image preview.
	var gallery = { list: [], index: -1 };

	// Markdown-preview return context: when an image INSIDE a rendered .md
	// preview is opened fullscreen, closing it should return to the markdown
	// document, not to the folder list. We cache the rendered md HTML + its
	// image entries here (set while rendering .md, cleared on close-to-list).
	var mdPreviewStack = null; // { html, path, name, imgs } | null

	function isImageName(name) {
		return IMG_EXT.indexOf(fileExt(name)) >= 0;
	}

	// True when the web view can PREVIEW this file type (text, image, pdf,
	// docx). Everything else (zip, exe, unknown binaries, ...) shows only a
	// small "not supported" popup at the clicked entry instead of an empty
	// overlay.
	function previewSupported(name) {
		var ext = fileExt(name);
		return TEXT_EXT.indexOf(ext) >= 0 || IMG_EXT.indexOf(ext) >= 0 || ext === "pdf" || VIDEO_EXT.indexOf(ext) >= 0 || DOCX_EXT.indexOf(ext) >= 0 || XLSX_EXT.indexOf(ext) >= 0;
	}

	// ALL Notifications laufen ueber den Standard-Frappe-Alert (Gerald, 2026-10):
	// der eigene, am Element verankerte Toast ist komplett entfernt.
	function showAlert(text, indicator, seconds) {
		frappe.show_alert({ message: text, indicator: indicator || "orange" }, seconds || 5);
	}

	// Uniform loading indicator for EVERY preview type (pdf, image, video,
	// text, docx, xlsx): same "Laden…" wording plus a small CSS spinner to its
	// left, so something keeps moving while a file is fetched or rendered
	// (Gerald, 2026-10-22). `overlay` is used by the PDF branch, where the
	// indicator must sit ON TOP of the iframe instead of next to it.
	function previewLoading(overlay) {
		var box = el("div", "ncweb-preview-text-loading" + (overlay ? " ncweb-preview-loading-overlay" : ""));
		box.appendChild(el("span", "ncweb-preview-spinner"));
		box.appendChild(el("span", null, t("Loading")));
		return box;
	}

	// Zoom +/- buttons in the preview header. Shown only while an IMAGE is
	// previewed; Ctrl+wheel also zooms (browser page zoom stays untouched).
	// The buttons zoom towards the CONTAINER CENTER (no cx/cy), the wheel
	// zooms towards the pointer. zoomImg (module scope) always points at the
	// currently displayed image — no re-wiring per image (Gerald).
	function setZoomControls(show, img) {
		var ov = document.getElementById("ncweb-preview");
		if (!ov) return;
		var body = document.getElementById("ncweb-preview-body");
		if (show) {
			zoomImg = img || null;
			wireZoom(body);
		}
		var zoomWrap = ov.querySelector(".ncweb-zoom");
		if (show && !zoomWrap) {
			zoomWrap = el("div", "ncweb-zoom");
			var plus = el("button", "ncweb-zoom-btn", "+");
			plus.type = "button";
			var minus = el("button", "ncweb-zoom-btn", "−");
			minus.type = "button";
			var reset = el("button", "ncweb-zoom-btn ncweb-zoom-reset", "1:1");
			reset.type = "button";
			plus.addEventListener("click", function (ev) { ev.preventDefault(); zoomBy(0.5); });
			minus.addEventListener("click", function (ev) { ev.preventDefault(); zoomBy(-0.5); });
			reset.addEventListener("click", function (ev) { ev.preventDefault(); resetZoom(); });
			zoomWrap.appendChild(plus);
			zoomWrap.appendChild(minus);
			zoomWrap.appendChild(reset);
			ov.appendChild(zoomWrap);
		} else if (show && zoomWrap) {
			// New image: keep the buttons as-is (zoomBy/resetZoom resolve the
			// current image via zoomImg) — just reset the old zoom state.
			zoomState.scale = 1; zoomState.x = 0; zoomState.y = 0;
			applyZoom();
		} else if (!show && zoomWrap) {
			zoomImg = null;
			zoomWrap.remove();
		}
	}

	// Named downloads no longer need a client-side blob hack: the
	// /ncfileviewer download route itself answers with
	// `Content-Disposition: attachment` + the REAL Nextcloud file name for
	// files up to DOWNLOAD_STREAM_LIMIT (renderer-side, 2026-10). Nextcloud's
	// own public share endpoints never send that header for single files
	// (verified across every URL form on NC 33 — even NC's UI works around
	// it client-side), so the renderer streams the file and the browser
	// downloads it under the real name while this page stays open. Files
	// ABOVE the limit get a 302 to the Nextcloud ORIGIN (CDN bypass, same
	// decision as video playback).
	// Inline previews fetch the WHOLE file through the ERP worker as well —
	// both for the worker's sake and because the renderer libraries would
	// choke on huge documents anyway, previews above these caps show a
	// clear "too large" hint instead (download button stays available).
	var DOCX_PREVIEW_LIMIT = 25 * 1024 * 1024;
	var PDF_PREVIEW_LIMIT = 50 * 1024 * 1024;

	function showPreviewTooLargeHint(name) {
		var body = document.getElementById("ncweb-preview-body");
		if (!body) return;
		var hint = el("div", "ncweb-preview-unsupported");
		hint.appendChild(el("span", "", t("The file is too large for an inline preview. Please download it.")));
		body.appendChild(hint);
	}

	// Update the header (title + download button) for the given file.
	// `size` (bytes, optional): unused since the renderer-side attachment
	// stream took over naming (kept for call-site compatibility).
	function setPreviewHeaderFile(path, name, size) {
		var title = document.getElementById("ncweb-preview-title");
		if (title) title.textContent = name || "";
		var dlBtn = document.getElementById("ncweb-preview-dl-btn");
		if (dlBtn) {
			// Rebind: clone to drop previous listeners, then attach the new one.
			var fresh = dlBtn.cloneNode(true);
			dlBtn.parentNode.replaceChild(fresh, dlBtn);
			fresh.id = "ncweb-preview-dl-btn";
			fresh.addEventListener("click", function (ev) {
				ev.preventDefault();
				// Readme images (direct mode): `path` is already a loadable
				// URL — download it as a link, not through the route endpoint.
				if (/^https?:/i.test(path || "") || (path || "").indexOf("/ncfileviewer/") === 0) {
					var a = document.createElement("a");
					a.href = path;
					a.download = name || "image";
					document.body.appendChild(a);
					a.click();
					a.remove();
					return;
				}
				// Same route as the row/tile downloads: the renderer streams
				// small files with `Content-Disposition: attachment` + the
				// REAL name (page stays open) and redirects big files to
				// the Nextcloud origin share stream.
				download(path, name);
			});
		}
	}

	// Show one image without touching the overlay shell.
	// `path` is either a route (built via previewUrl) or an already-final URL
	// (readme images, direct mode) — root-relative or http(s) URLs are used
	// as-is: a plain <img> with that src (same-origin session cookie) avoids
	// the blob roundtrip entirely and reports load errors via onerror.
	// ---- Image zoom (own loupe): prevents the BROWSER page zoom from
	// scaling the whole website. + / - / reset buttons (bottom right of the
	// header), Ctrl/Cmd+wheel, and PAN while zoomed (mouse drag / touch
	// swipe). State resets on every new image.
	var zoomState = { scale: 1, x: 0, y: 0 };
	// The image the zoom currently acts on (updated on every preview switch).
	// The event listeners are attached ONCE per preview body and resolve the
	// image dynamically — attaching them per image would stack duplicates
	// whose stale closures fight over the shared zoomState (that was the old
	// "center zoom after switching images" bug, Gerald).
	var zoomImg = null;
	var zoomWiredBody = null;
	function clampPan(img) {
		// Keep the image over its own viewport: at scale s the image is s times
		// bigger, so the free translate range per axis is (s-1)/2 * displayed
		// size (body acts as the clip window). Without this the image can be
		// dragged beyond its edges leaving empty space (shipped bug).
		img = img || zoomImg;
		if (!img) return;
		var body = document.getElementById("ncweb-preview-body");
		if (!body) return;
		var s = zoomState.scale;
		if (s <= 1) { zoomState.x = 0; zoomState.y = 0; return; }
		var maxX = (img.offsetWidth * (s - 1)) / 2;
		var maxY = (img.offsetHeight * (s - 1)) / 2;
		zoomState.x = Math.max(-maxX, Math.min(maxX, zoomState.x));
		zoomState.y = Math.max(-maxY, Math.min(maxY, zoomState.y));
	}
	function applyZoom(img) {
		img = img || zoomImg;
		if (!img) return;
		clampPan(img);
		img.style.transition = "transform 0.12s ease";
		img.style.transformOrigin = "center center";
		img.style.transform = "translate(" + zoomState.x + "px, " + zoomState.y + "px) scale(" + zoomState.scale + ")";
	}
	function resetZoom(img) {
		zoomState.scale = 1; zoomState.x = 0; zoomState.y = 0;
		applyZoom(img);
	}
	// Zoom towards a fixed image point. cx/cy are the viewport point (relative
	// to the container center) that must stay under the cursor: the image
	// point there is d = (c - (x, y)) / s, and after scaling it must map back
	// to c, so (x', y') = c - (c - (x, y)) * s'/s.
	// - wheel / Ctrl+wheel pass the MOUSE position (Gerald)
	// - the +/- buttons omit it -> c = (0, 0) = container center
	function zoomBy(delta, cx, cy) {
		var before = zoomState.scale;
		zoomState.scale = Math.min(7, Math.max(1, zoomState.scale + delta));
		if (zoomState.scale !== before) {
			if (cx === undefined) { cx = 0; cy = 0; }
			var f = zoomState.scale / before;
			zoomState.x = cx - (cx - zoomState.x) * f;
			zoomState.y = cy - (cy - zoomState.y) * f;
		}
		if (zoomState.scale === 1) { zoomState.x = 0; zoomState.y = 0; }
		applyZoom();
		return zoomState.scale !== before;
	}
		// Attach the zoom/pan listeners ONCE per preview body. They resolve the
	// image dynamically via zoomImg, so switching images needs NO re-wiring
	// (per-image wiring stacked duplicate listeners whose stale closures
	// fought over the shared zoomState — that was the old center-zoom bug).
	function wireZoom(body) {
		if (zoomWiredBody === body) return;
		zoomWiredBody = body;
		// Pan: mouse drag + touch swipe (only while zoomed in).
		var panning = false, startX = 0, startY = 0, baseX = 0, baseY = 0;
		body.addEventListener("mousedown", function (ev) {
			if (zoomState.scale <= 1) return;
			panning = true; startX = ev.clientX; startY = ev.clientY;
			baseX = zoomState.x; baseY = zoomState.y;
			ev.preventDefault();
		});
		document.addEventListener("mousemove", function (ev) {
			if (!panning) return;
			zoomState.x = baseX + (ev.clientX - startX);
			zoomState.y = baseY + (ev.clientY - startY);
			applyZoom();
		});
		document.addEventListener("mouseup", function () { panning = false; });
		body.addEventListener("touchstart", function (ev) {
			if (zoomState.scale <= 1 || ev.touches.length !== 1) return;
			panning = true; startX = ev.touches[0].clientX; startY = ev.touches[0].clientY;
			baseX = zoomState.x; baseY = zoomState.y;
		}, { passive: true });
		body.addEventListener("touchmove", function (ev) {
			if (!panning || ev.touches.length !== 1) return;
			ev.preventDefault();
			zoomState.x = baseX + (ev.touches[0].clientX - startX);
			zoomState.y = baseY + (ev.touches[0].clientY - startY);
			applyZoom();
		}, { passive: false });
		body.addEventListener("touchend", function () { panning = false; });
		// Plain wheel AND Ctrl/Cmd+wheel = zoom the IMAGE at the pointer.
		// preventDefault keeps the BROWSER page zoom out of it — the website
		// around the overlay stays untouched (Gerald). Without an image
		// (text/markdown preview) the wheel must SCROLL normally.
		body.addEventListener("wheel", function (ev) {
			if (!zoomImg) return; // no image: let the container scroll
			ev.preventDefault();
			var rect = body.getBoundingClientRect();
			var cx = ev.clientX - (rect.left + rect.width / 2);
			var cy = ev.clientY - (rect.top + rect.height / 2);
			zoomBy(ev.deltaY < 0 ? 0.25 : -0.25, cx, cy);
		}, { passive: false });
	}

	function showImageInPreview(path, name) {
		var body = document.getElementById("ncweb-preview-body");
		if (!body) return;
		body.textContent = "";
		// Zoom + pan run via CSS transform with clamped bounds — the body must
		// NOT scroll for images (its scrollbars would fight the translate).
		body.style.overflow = "hidden";
		zoomState.scale = 1; zoomState.x = 0; zoomState.y = 0;
		setPreviewHeaderFile(path, name);
		var p = path || "";
		if (/^https?:/i.test(p) || p.indexOf("/") === 0) {
			var img0 = el("img", "ncweb-preview-img");
			img0.alt = name || "";
			img0.onerror = function () {
				setZoomControls(false);
				img0.remove();
				body.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
			};
			img0.src = p;
			body.appendChild(img0);
			setZoomControls(true, img0);
			return;
		}
		body.appendChild(previewLoading());
		cachedImageBlobUrl(p)
			.then(function (url) {
				if (body.firstChild) body.firstChild.remove();
				var img = el("img", "ncweb-preview-img");
				img.alt = name || "";
				img.src = url;
				body.appendChild(img);
				setZoomControls(true, img);
			})
			.catch(function () {
				if (body.firstChild) body.firstChild.remove();
				body.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
			});
	}

	// Collect the images of the current folder (in the displayed sort order) and
	// start the slideshow at the clicked image.
	function openImageGallery(path) {
		// Build the slideshow from the CURRENTLY VISIBLE entries (respects
		// the live search filter - Gerald: photos must be in the shown list).
		var imgs = sortEntries(visibleEntries()).filter(function (e) {
			return e && !e.is_dir && isImageName(e.name);
		});
		gallery.list = imgs;
		gallery.index = 0;
		for (var i = 0; i < imgs.length; i++) {
			if (imgs[i].path === path) { gallery.index = i; break; }
		}
		syncGalleryNav();
		var cur = imgs[gallery.index];
		if (cur) showImageInPreview(cur.path, cur.name);
	}

	// Move the slideshow by delta (+1 next / -1 previous), wrapping around.
	function galleryStep(delta) {
		if (gallery.list.length < 2) return;
		gallery.index = (gallery.index + delta + gallery.list.length) % gallery.list.length;
		var cur = gallery.list[gallery.index];
		if (cur) showImageInPreview(cur.path, cur.name);
	}

	// Add the overlay class that reveals the prev/next buttons (only for >1 image).
	function syncGalleryNav() {
		var ov = document.getElementById("ncweb-preview");
		if (!ov) return;
		var many = gallery.list.length > 1;
		if (many) ov.classList.add("ncweb-preview-gallery");
		else ov.classList.remove("ncweb-preview-gallery");
	}

	// Direct download via a short-lived Nextcloud share: the browser is
	// redirected to the share's /download URL and streams straight from
	// Nextcloud (no ERP worker involved in the data transfer). Works for files
	// and (subfolder-free) folders alike; the server enforces access rules.
	function shareDownloadUrl(path) {
		var segs = (path || "").split("/").filter(Boolean);
		return "/ncfileviewer/" + encodeURIComponent(mountpointName) + "/"
			+ segs.map(function (s) { return encodeURIComponent(s); }).join("/")
			+ "?zip=1";
	}

	// Download via the share URL, but PROBE the server first (?check=1).
	// The server rejects a folder ZIP that contains subfolders — without the
	// probe the browser would navigate to a bare error page; with it the
	// message surfaces as a Frappe alert ON this page (Gerald 2026-10).
	function shareDownload(path) {
		var url = shareDownloadUrl(path);
		fetch(url + "&check=1", { credentials: "same-origin" })
			.then(function (r) {
				if (r.ok) {
					// Probe passed: start the real download (302 to the share).
					window.location.href = url;
					return;
				}
				return r.text().then(function (body) {
					var msg = "";
					try { msg = (JSON.parse(body) || {}).message || ""; } catch (e) { msg = ""; }
					if (!msg) msg = (body || "").trim();
					var err = new Error(msg || t("Download failed"));
					err.friendlyMessage = err.message;
					throw err;
				});
			})
			.catch(function (err) {
				// friendlyMessage = the server's translated message; anything
				// else (network error etc.) gets the generic i18n string.
				showAlert((err && err.friendlyMessage) || t("Download failed"), "red");
			});
	}

	// Blob cache for image previews: maps path -> objectURL. It is scoped to
	// the CURRENT folder (keyed by currentRoute) and cleared on navigation /
	// reload so stale files are never shown (Gerald). Kachel and preview use
	// the SAME cache so a file is fetched only once per folder.
	var imageBlobCache = {};
	var imageBlobCacheRoute = "";

	function resetImageBlobCache() {
		Object.keys(imageBlobCache).forEach(function (k) {
			try { URL.revokeObjectURL(imageBlobCache[k]); } catch (e) {}
		});
		imageBlobCache = {};
		imageBlobCacheRoute = currentRoute || "";
	}

	function previewUrl(path) {
		var p = new URLSearchParams();
		p.set("view_id", mountpointName);
		p.set("route", path || "");
		return curl() + EP_PREVIEW + "?" + p.toString();
	}

	// Fetch the preview blob with caching: returns a Promise of an objectURL.
	// The cache is route-scoped; a navigation clears it (see load()).
	function cachedImageBlobUrl(path) {
		if (imageBlobCacheRoute !== (currentRoute || "")) {
			resetImageBlobCache();
		}
		if (imageBlobCache[path]) {
			return Promise.resolve(imageBlobCache[path]);
		}
		return fetch(previewUrl(path), { credentials: "same-origin" })
			.then(function (r) {
				if (!r.ok) throw new Error(r.status);
				return r.blob();
			})
			.then(function (blob) {
				var url = URL.createObjectURL(blob);
				imageBlobCache[path] = url;
				return url;
			});
	}

	// URL for the dedicated inline file viewer. The trailing URL segment is the
	// real file name, so the browser's built-in PDF viewer shows it with the
	// correct title and names a download after it. (Access is enforced by the
	// renderer; the session cookie is sent because the iframe is same-origin.)
	// Server-side thumbnail URL (small preview via NC preview API). The grid
	// tile sets this DIRECTLY as src (no blob promise) so the image appears
	// immediately and never flashes a "not found" while loading.
	function thumbUrl(path) {
		var p = new URLSearchParams();
		p.set("view_id", mountpointName);
		p.set("route", path || "");
		return curl() + EP_THUMB + "?" + p.toString();
	}

	function fileViewerUrl(path) {
		var segs = (path || "").split("/").filter(Boolean);
		return "/ncfileviewer/" + encodeURIComponent(mountpointName) + "/"
			+ segs.map(function (s) { return encodeURIComponent(s); }).join("/");
	}

	function fileExt(name) {
		var i = (name || "").lastIndexOf(".");
		return i >= 0 ? name.slice(i + 1).toLowerCase() : "";
	}

	function openPreview(path, name, contentType, size, directList, directIndex) {
		var ov = document.getElementById("ncweb-preview");
		var body = document.getElementById("ncweb-preview-body");
		var title = document.getElementById("ncweb-preview-title");
		if (!ov || !body) return;
		// Readme-gallery mode: the caller supplies a ready list of image
		// entries whose `path` values are ALREADY loadable URLs (ncfileviewer),
		// so the regular path-based preview URL building is skipped.
		var directMode = Array.isArray(directList) && directList.length > 0;
		if (directMode) {
			gallery.list = directList;
			gallery.index = directIndex || 0;
			syncGalleryNav();
		}
		body.textContent = "";
		// A previous spreadsheet preview leaves a running Univer engine
		// bound to the (now removed) container — destroy it on every new
		// preview and on close (no-op when none is open).
		try {
			if (window.NCUniverViewLib) window.NCUniverViewLib.destroy();
		} catch (e) { /* ignore */ }
		// The header download button works for EVERY file type (also those
		// without an inline preview); wire it with the current file. The
		// entry size decides: small files download under their REAL name via
		// the session-authed blob path, large ones via the share stream.
		setPreviewHeaderFile(path, name, typeof size === "number" ? size : null);
		if (IMG_EXT.indexOf(fileExt(name)) < 0) setZoomControls(false);
		if (!directMode) {
			// Leaving any earlier image slideshow unless a readme gallery was
			// just handed over (directMode already set the gallery above).
			gallery.list = [];
			gallery.index = -1;
			syncGalleryNav();
		}
		// Start the overlay below the Frappe website header (only the header
		// stays visible); top: 0 from CSS is the fallback when none exists.
		// Use the header's FULL height (offsetHeight), never the scrolled
		// rect.bottom: when the page is scrolled the sticky header can be
		// partially out of view and the overlay would start too high, hiding
		// part of the header bar (Gerald: always show the FULL header).
		try {
			var siteHeader = document.getElementById("header")
				|| document.querySelector(".navbar, .web-header");
			if (siteHeader) {
				var headerH = siteHeader.offsetHeight
					|| siteHeader.getBoundingClientRect().height
					|| 0;
				ov.style.top = Math.max(0, Math.ceil(headerH)) + "px";
			}
		} catch (e) { /* keep CSS fallback */ }
		// Freeze the underlying page scroll while the overlay is open: the Frappe
		// website content below can be marginally taller than the viewport, which
		// would otherwise show a tiny outer scroll bar beside the overlay.
		try {
			// Lock scrolling on BOTH <html> and <body>: with Frappe web templates
			// the page overflow can live on the root element, so locking only the
			// body leaves the minimal outer scroll visible. The previous value is
			// remembered ONCE — nested openPreview calls (e.g. an image opened
			// from a markdown preview) must not overwrite it with "hidden" (that
			// would restore a locked page after the final close, Gerald).
			var de = document.documentElement;
			if (!("__ncwebPrevOverflow" in de)) de.__ncwebPrevOverflow = de.style.overflow;
			if (!("__ncwebPrevOverflow" in document.body)) document.body.__ncwebPrevOverflow = document.body.style.overflow;
			de.style.overflow = "hidden";
			document.body.style.overflow = "hidden";
		} catch (e) { /* ignore */ }
		ov.style.display = "flex";

		// Direct-mode entries carry the plain ROUTE (for previewUrl + download) and
		// the final image URL; for list entries the URL is built from the route.
		var ext = fileExt(name);
		var url = directMode ? (gallery.list[gallery.index] || {}).url : previewUrl(path);

		if (IMG_EXT.indexOf(ext) >= 0) {
			if (directMode) {
				// Readme image: route-based loading (identical code path to
				// list previews, including blob fetch with session creds).
				showImageInPreview(path, name);
			} else {
				// Images: slideshow over all images in the current folder. The
				// clicked image is shown first; prev/next cycle through the rest.
				openImageGallery(path);
			}
		} else if (ext === "pdf") {
			if (typeof size === "number" && size > PDF_PREVIEW_LIMIT) {
				// Huge PDF: the iframe streams through the ERP worker — a slow
				// partner connection would hold it past the gunicorn timeout.
				showPreviewTooLargeHint(name);
			} else {
			// PDF: load the whitelisted endpoint directly in an iframe. The
			// endpoint is a plain GET (no CSRF token required) and, same-origin,
			// the iframe sends the session cookie automatically. The response
			// carries Content-Disposition: inline; filename="...", so the
			// browser's built-in PDF viewer shows the file inline and uses the
			// real filename (not a cryptic blob id) when the user downloads it.
			// The "Laden…" indicator (same as every other preview type) sits
			// ON TOP of the iframe and disappears when the PDF document is
			// loaded - with a safety net so it can never hang forever
			// (Gerald, 2026-10-22).
			var wrap = el("div", "ncweb-preview-pdf-wrap");
			var loading = previewLoading(true);
			var iframe = el("iframe", "ncweb-preview-pdf");
			var dropLoading = function () {
				if (loading.parentNode) loading.remove();
			};
			iframe.addEventListener("load", dropLoading);
			setTimeout(dropLoading, 15000);
			iframe.src = fileViewerUrl(path);
			iframe.setAttribute("frameborder", "0");
			wrap.appendChild(loading);
			wrap.appendChild(iframe);
			body.appendChild(wrap);
		}
		} else if (DOCX_EXT.indexOf(ext) >= 0) {
			// Word documents: rendered client-side with docx-preview (read-only,
			// layout-faithful HTML). Vendor scripts load lazily on first use.
			// Size cap: the whole file streams through the ERP worker — huge
			// documents would hold it past the gunicorn timeout on slow
			// connections (and docx-preview could not render them anyway).
			if (typeof size === "number" && size > DOCX_PREVIEW_LIMIT) {
				showPreviewTooLargeHint(name);
			} else {
				// docx-preview cannot reproduce every shape/font of a Word
				// document. Say so up front (standard Frappe alert, default
				// duration) so a simplified rendering is never mistaken for a
				// broken document (Gerald, 2026-10-22).
				showAlert(t(DOCX_PREVIEW_HINT), "blue");
				renderDocxPreview(path, name);
			}
		} else if (XLSX_EXT.indexOf(ext) >= 0) {
			// Spreadsheets (xlsx/xlsm/csv): Univer read-only viewer, lazy-loaded.
			// Same size cap logic as docx above.
			if (typeof size === "number" && size > DOCX_PREVIEW_LIMIT) {
				showPreviewTooLargeHint(name);
			} else {
				renderXlsxPreview(path, name);
			}
		} else if (TEXT_EXT.indexOf(ext) >= 0) {
			body.appendChild(previewLoading());
			fetch(url, { credentials: "same-origin" })
				.then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
				.then(function (txt) {
					if (body.firstChild) body.firstChild.remove();
					if (ext === "md") {
						// Markdown: the backend renders it through the SAME
						// pipeline as the folder readme (callouts, details,
						// tables, relative images). Show the rendered HTML —
						// links open in a new tab, images open the gallery.
						var mdBox = el("div", "ncweb-preview-md");
						mdBox.innerHTML = txt;
						mdBox.querySelectorAll("a").forEach(function (a) {
							a.target = "_blank";
							a.rel = "noopener noreferrer";
						});
						var mdImgs = Array.prototype.slice.call(mdBox.querySelectorAll("img"));
						// Cache the md document so closing a fullscreen image
						// preview returns HERE instead of the folder list.
						mdPreviewStack = {
							html: txt,
							path: path,
							name: name,
							imgs: mdImgs.map(function (img) {
								var src = img.getAttribute("src") || "";
								var after = src.split("?")[0];
								var mpSeg = "/ncfileviewer/" + encodeURIComponent(mountpointName) + "/";
								if (after.indexOf(mpSeg) === 0) {
									after = after.substring(mpSeg.length);
								} else {
									after = after.replace(/^.*?\/ncfileviewer\/[^/]+\//, "");
								}
								var route = after.split("/").map(decodeURIComponent).join("/");
								return {
									path: route,
									url: src,
									name: decodeURIComponent(src.split("?")[0].split("/").pop() || "image")
								};
							})
						};
						mdImgs.forEach(function (img, i) {
							img.style.cursor = "pointer";
							img.addEventListener("click", function (ev) {
								ev.preventDefault();
								openReadmeGallery(mdImgs, i);
							});
						});
						body.appendChild(mdBox);
					} else {
						var pre = el("pre", "ncweb-preview-text");
						pre.textContent = txt;
						body.appendChild(pre);
					}
				})
				.catch(function () {
					if (body.firstChild) body.firstChild.remove();
					body.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
				});
		} else if (VIDEO_EXT.indexOf(ext) >= 0) {
			// Video: native <video> element. The source must point DIRECTLY at
			// the Nextcloud share URL: a 302 hop through the ERP breaks HTTP
			// Range requests (the browser cannot re-issue Range across the
			// redirect), which caused full downloads before playback and
			// broken seeking. The endpoint returns JSON {url}; it creates the
			// short-lived share (TTL, sweep-queued) and enforces access.
			// If the share EXPIRES while watching (sweep deletes it after the
			// TTL), the next out-of-buffer seek errors — the error handler
			// then fetches a FRESH share and resumes at the same position
			// (Gerald: video must stay usable beyond the share TTL).
			function fetchVideoShare() {
				return fetch(
					curl() + "pit_erpnext.scripts.nc_public_web.nc_share_cleanup.get_video_share_url",
					{
						method: "POST",
						credentials: "same-origin",
						headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", "X-Frappe-CSRF-Token": csrf() },
						body: (function () {
							var f2 = new URLSearchParams();
							f2.set("view_id", mountpointName);
							f2.set("route", path || "");
							return f2.toString();
						})()
					}
				).then(function (r) {
					if (!r.ok) throw new Error(r.status);
					return r.json();
				}).then(function (res) {
					var u = (res && res.message && res.message.url) || "";
					if (!u) throw new Error("no url");
					return u;
				});
			}
			body.appendChild(previewLoading());
			fetchVideoShare().then(function (url2) {
				if (body.firstChild) body.firstChild.remove();
				var vid = el("video", "ncweb-preview-video");
				vid.controls = true;
				vid.autoplay = true;
				vid.preload = "metadata";
				vid.src = url2;
				// Expired-share recovery: on a load/seek error get a fresh
				// share once, restore the position and continue playback.
				vid.addEventListener("error", function () {
					if (vid.__ncwebRecovering) return; // one retry per error
					vid.__ncwebRecovering = true;
					var resumeAt = vid.currentTime || 0;
					var wasPlaying = !vid.paused;
					fetchVideoShare().then(function (fresh) {
						vid.src = fresh;
						vid.addEventListener("loadedmetadata", function () {
							try { vid.currentTime = resumeAt; } catch (e) { /* ignore */ }
							if (wasPlaying) vid.play().catch(function () { /* ignore */ });
						}, { once: true });
					}).catch(function () {
						// Renewal failed (e.g. access lost): show the error UI.
						if (body.firstChild) body.firstChild.remove();
						body.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
					});
				});
				body.appendChild(vid);
			}).catch(function () {
				if (body.firstChild) body.firstChild.remove();
				body.appendChild(el("div", "ncweb-preview-error", t("Preview could not be loaded.")));
			});
		} else {
			// Unsupported preview: text hint only — the download is offered by
			// the header button (top right) for every file type.
			var hint = el("div", "ncweb-preview-unsupported");
			hint.appendChild(el("span", "", t("No preview available for this file type.")));
			body.appendChild(hint);
		}
	}

	function closePreview() {
		var ov = document.getElementById("ncweb-preview");
		var body = document.getElementById("ncweb-preview-body");
		// If a fullscreen image was opened FROM a rendered markdown preview,
		// closing it returns to the markdown document (Gerald) instead of
		// leaving the overlay (which would dump the user into the folder list).
		if (mdPreviewStack && gallery.list.length) {
			// Rebuild the markdown preview in the overlay body.
			var mdBox2 = el("div", "ncweb-preview-md");
			mdBox2.innerHTML = mdPreviewStack.html;
			mdBox2.querySelectorAll("a").forEach(function (a) {
				a.target = "_blank";
				a.rel = "noopener noreferrer";
			});
			var mdImgs2 = Array.prototype.slice.call(mdBox2.querySelectorAll("img"));
			mdImgs2.forEach(function (img, i) {
				img.style.cursor = "pointer";
				img.addEventListener("click", function (ev) {
					ev.preventDefault();
					openReadmeGallery(mdImgs2, i);
				});
			});
			if (body) {
				body.textContent = "";
				body.style.overflow = ""; // clear the image zoom's overflow:hidden
				body.appendChild(mdBox2);
			}
			setPreviewHeaderFile(mdPreviewStack.path, mdPreviewStack.name);
			setZoomControls(false);
			gallery.list = [];
			gallery.index = -1;
			syncGalleryNav();
			return; // overlay stays open, back to the markdown
		}
		// Normal close: leave the overlay entirely.
		mdPreviewStack = null;
		if (body) body.style.overflow = ""; // restore for non-image previews
		// Destroy a running Univer instance BEFORE the body is emptied: the
		// engine holds timers/render loop bound to its container element.
		try {
			if (window.NCUniverViewLib) window.NCUniverViewLib.destroy();
		} catch (e) { /* never block the close */ }
		if (ov) ov.style.display = "none";
		if (ov) ov.classList.remove("ncweb-preview-gallery");
		gallery.list = [];
		gallery.index = -1;
		if (body) body.textContent = "";
		// Restore page scroll that was locked while the overlay was open.
		try {
			var de2 = document.documentElement;
			var prevHtml = de2.__ncwebPrevOverflow;
			var prevBody = document.body.__ncwebPrevOverflow;
			delete de2.__ncwebPrevOverflow;
			delete document.body.__ncwebPrevOverflow;
			de2.style.overflow = prevHtml || "";
			document.body.style.overflow = prevBody || "";
		} catch (e) { /* ignore */ }
	}

	// Wire the slideshow navigation buttons (no-ops on non-image previews).
	(function () {
		var prevBtn = document.getElementById("ncweb-preview-prev");
		var nextBtn = document.getElementById("ncweb-preview-next");
		if (prevBtn) prevBtn.addEventListener("click", function (ev) { ev.preventDefault(); galleryStep(-1); });
		if (nextBtn) nextBtn.addEventListener("click", function (ev) { ev.preventDefault(); galleryStep(1); });
	})();

	// Wire the overlay close actions (backdrop click + close button + Esc).
	document.addEventListener("click", function (ev) {
		if (ev.target && ev.target.closest && ev.target.closest("[data-close-preview]")) {
			closePreview();
		}
	});
	document.addEventListener("keydown", function (ev) {
		if (ev.key === "Escape") { closePreview(); return; }
		// Slideshow: left/right arrows step through images while a slideshow is
		// active (the overlay is open and holds more than one image).
		if (gallery.list.length > 1) {
			var ov = document.getElementById("ncweb-preview");
			var open = ov && ov.style.display !== "none";
			if (open && ev.key === "ArrowLeft") { ev.preventDefault(); galleryStep(-1); }
			else if (open && ev.key === "ArrowRight") { ev.preventDefault(); galleryStep(1); }
		}
	});

	function curl() {
		// Frappe exposes the API base path via frappe.urllib; fall back to /api/method/.
		if (window.frappe && frappe.urllib && frappe.urllib.api_base) {
			return frappe.urllib.api_base;
		}
		return "/api/method/";
	}

	function csrf() {
		return (window.frappe && frappe.csrf_token) || window.csrf_token || "";
	}

	function exceptionMessage(res) {
		try {
			var exc = JSON.parse(res.exc);
			if (exc && exc.length) {
				var msg = (exc[0] && exc[0].message) || "";
				if (msg) return msg;
			}
		} catch (e) { /* ignore */ }
		return res.message || t("An error occurred");
	}

	// Read the initial route from the ?folder= query param (deep links / refresh).
	(function () {
		try {
			var qs = new URLSearchParams(window.location.search);
			var folder = qs.get("folder");
			if (folder) {
				currentRoute = folder;
			}
		} catch (e) { /* ignore */ }
	})();

	// Back/forward navigation: reload the folder from the URL's ?folder= param.
	window.addEventListener("popstate", function () {
		try {
			var qs = new URLSearchParams(window.location.search);
			var folder = qs.get("folder") || "";
			currentRoute = folder || "";
		} catch (e) {
			currentRoute = "";
		}
		load(false);
	});

	// Recalculate breadcrumbs when the window is resized (collapse/expand the
	// "..." menu according to the available width). Debounced to avoid
	// excessive re-renders while dragging the window.
	var resizeTimer = null;
	function scheduleBreadcrumbRecalc() {
		if (resizeTimer) clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			updateBreadcrumb();
		}, 150);
	}
	window.addEventListener("resize", scheduleBreadcrumbRecalc);
	// Fonts may swap in AFTER the first layout (making crumbs wider). Re-run
	// the collapse logic once fonts are ready and once on the next frame, so
	// the edge case "new big crumb barely overflows" is always handled.
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function () { scheduleBreadcrumbRecalc(); });
	}
	requestAnimationFrame(function () { scheduleBreadcrumbRecalc(); });

	// Initialize sorting (header buttons + initial arrow state) once loaded.
	setupSortHandlers();
	updateSortArrows();
	buildToolbar();

	// Host API for the upload / new-folder extension (nextcloud_location_upload.js).
	// The extension is a separate file so this 2k-line browser keeps its job;
	// it reuses the page helpers instead of duplicating them.
	window.NCWeb = {
		t: t,
		el: el,
		svgEl: svgEl,
		curl: curl,
		csrf: csrf,
		exceptionMessage: exceptionMessage,
		showAlert: showAlert,
		reload: function () { load(false); },
		getRoute: function () { return currentRoute; },
		getViewId: function () { return mountpointName; },
		getDisplayName: function () { return mountpointDisplayName; },
		// Endpoints of the write actions: read from #ncweb-root so ONE upload
		// script serves both pages (/nextcloud/<id> and /nextcloud-location/<name>).
		getUploadMethod: function () {
			return rootEl.getAttribute("data-upload-method")
				|| NC_API + "nc_web_view.nc_web_upload";
		},
		getFolderMethod: function () {
			return rootEl.getAttribute("data-folder-method")
				|| NC_API + "nc_web_view.nc_web_create_folder";
		},
		getRenameMethod: function () {
			return rootEl.getAttribute("data-rename-method")
				|| NC_API + "nc_web_view.nc_web_rename";
		},
		getDeleteMethod: function () {
			return rootEl.getAttribute("data-delete-method")
				|| NC_API + "nc_web_view.nc_web_delete";
		},
		// The row/tile menu helpers: the write extension adds its own items
		// (Rename / Delete) and closes the dropdown through these.
		closeMenu: closeMenu,
		// Per-folder write right of the CURRENT listing ("upload" also covers
		// creating folders). One gate for every write control.
		can: function (action) { return !!rights[action]; },
		isReadOnly: function () { return readOnly; },
		getNameRules: function () { return nameRules; },
		getMaxUploadMb: function () { return maxUploadMb; }
	};
	try {
		document.dispatchEvent(new CustomEvent("ncweb:ready", { detail: window.NCWeb }));
	} catch (e) { /* ignore */ }

	// web_include_js places the bundle at the END of <body>, but Frappe sets
	// `frappe.csrf_token` in the very LAST inline script - i.e. AFTER the bundle.
	// The first listing POST must therefore wait for DOMContentLoaded, otherwise
	// it goes out without a CSRF token and Frappe answers 400 (the UI shows
	// "Antwort unerwartet."). The former <script defer> tags ran once the whole
	// document was parsed, so this only appeared after the bundle switch.
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () { load(false); });
	} else {
		load(false);
	}
})();